/**
 * Generated by orval v7.19.0 🍺
 * Do not edit manually.
 * GTO Wizard API v4
 * API documentation for GTO Wizard frontend API
 * OpenAPI spec version: 4
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query'

import type {
  AdminAffiliateTierSchema,
  AffiliateAdminAccessChangeListResponseSchema,
  AffiliateAdminAccessGrantSchema,
  AffiliateAdminAccessSchema,
  AffiliateAdminCommissionCorrectionResponseSchema,
  AffiliateAdminCommissionCorrectionSchema,
  AffiliateAdminCommissionSchema,
  AffiliateAdminCouponListSchema,
  AffiliateAdminCouponSchema,
  AffiliateAdminLedgerResponseSchema,
  AffiliateAdminOrderListResponseSchema,
  AffiliateAdminPartnerCouponListResponseSchema,
  AffiliateAdminPartnerDetailSchema,
  AffiliateAdminPartnerListResponseSchema,
  AffiliateAdminPartnerUpdateSchema,
  AffiliateAdminPayoutSchema,
  AffiliateAnalyticsResponseSchema,
  AffiliateAssetRenameSchema,
  AffiliateAssetSchema,
  AffiliateAssetUploadRequestSchema,
  AffiliateAssetUploadResponseSchema,
  AffiliateChannelOverviewSchema,
  AffiliateCouponWithStatsSchema,
  AffiliateCreateCouponSchema,
  AffiliateCreateSettlementSchema,
  AffiliateCreateTierSchema,
  AffiliateEligiblePayoutSchema,
  AffiliateNextBatchResponseSchema,
  AffiliatePartnerAssetSchema,
  AffiliatePartnerLeaderboardResponseSchema,
  AffiliatePartnerProfileSchema,
  AffiliatePartnerStatsSchema,
  AffiliatePartnerStatusResponseSchema,
  AffiliatePaymentMethodRequestSchema,
  AffiliatePaymentMethodResponseSchema,
  AffiliatePayoutAdjustAmountSchema,
  AffiliatePayoutSchema,
  AffiliatePayoutStatusUpdateSchema,
  AffiliateProgramStatsSchema,
  AffiliateRegisterRequest,
  AffiliateRegisterResponse,
  AffiliateRejectSuspendSchema,
  AffiliateSettlementDetailSchema,
  AffiliateSettlementListSchema,
  AffiliateUpdateCouponSchema,
  AffiliateUpdateProfileSchema,
  AffiliateUpdateSettlementPayoutsSchema,
  AffiliateUpdateTierSchema,
  AffiliateActivatePartnerSchema,
  AffiliateAdminCreatePartnerSchema,
  ApprovePartnerBody,
  CancelSettlementView200,
  DeleteAsset200,
  DeleteCoupon200,
  DeleteTier200,
  ErrorResponse,
  GetAdminLedgerParams,
  GetMyAnalyticsParams,
  GetMyCommissionsParams,
  GetPartnerAnalyticsViewParams,
  GetPartnerStatsViewParams,
  GetProgramAnalyticsViewParams,
  GetProgramLeaderboardViewParams,
  GetProgramStatsViewParams,
  ListAdminAccessChangesParams,
  ListAllCouponsParams,
  ListAssetsParams,
  ListEligiblePayoutsParams,
  ListOrdersParams,
  ListPartnerAssetsParams,
  ListPartnerCommissionsParams,
  ListPartnerCouponsParams,
  ListPartnersParams,
  ListPayoutsParams,
  ListSettlementsParams,
  PagedAffiliateCommissionSchema,
} from '../models'

import registerAffiliateMutator from '../../client'
import registerAffiliatePublicMutator from '../../client'
import getMyProfileMutator from '../../client'
import updateMyProfileMutator from '../../client'
import acceptMyTermsMutator from '../../client'
import updatePaymentMethodMutator from '../../client'
import getMyStatsMutator from '../../client'
import getMyAnalyticsMutator from '../../client'
import getMyCommissionsMutator from '../../client'
import getMyCouponsMutator from '../../client'
import requestPayoutMutator from '../../client'
import getMyPayoutsMutator from '../../client'
import listPartnerAssetsMutator from '../../client'
import getProgramStatsViewMutator from '../../client'
import getProgramLeaderboardViewMutator from '../../client'
import getNextBatchViewMutator from '../../client'
import getProgramAnalyticsViewMutator from '../../client'
import listPartnersMutator from '../../client'
import getPartnerMutator from '../../client'
import updatePartnerMutator from '../../client'
import getPartnerStatsViewMutator from '../../client'
import getPartnerAnalyticsViewMutator from '../../client'
import createPartnerMutator from '../../client'
import activatePartnerMutator from '../../client'
import approvePartnerMutator from '../../client'
import rejectPartnerMutator from '../../client'
import suspendPartnerMutator from '../../client'
import listPartnerCouponsMutator from '../../client'
import createCouponMutator from '../../client'
import updateCouponMutator from '../../client'
import deleteCouponMutator from '../../client'
import listAllCouponsMutator from '../../client'
import listPartnerCommissionsMutator from '../../client'
import createPartnerCommissionCorrectionMutator from '../../client'
import listOrdersMutator from '../../client'
import listTiersMutator from '../../client'
import createTierMutator from '../../client'
import updateTierMutator from '../../client'
import deleteTierMutator from '../../client'
import listPayoutsMutator from '../../client'
import updatePayoutStatusMutator from '../../client'
import adjustPayoutAmountMutator from '../../client'
import getAdminLedgerMutator from '../../client'
import listAdminAccessMutator from '../../client'
import listAdminAccessChangesMutator from '../../client'
import grantAdminAccessViewMutator from '../../client'
import revokeAdminAccessViewMutator from '../../client'
import listAssetsMutator from '../../client'
import uploadAssetMutator from '../../client'
import renameAssetMutator from '../../client'
import deleteAssetMutator from '../../client'
import getOverviewMutator from '../../client'
import listEligiblePayoutsMutator from '../../client'
import listSettlementsMutator from '../../client'
import createSettlementViewMutator from '../../client'
import getSettlementMutator from '../../client'
import updateSettlementViewMutator from '../../client'
import cancelSettlementViewMutator from '../../client'
import confirmSettlementViewMutator from '../../client'
import processSettlementViewMutator from '../../client'
import exportSettlementCsvMutator from '../../client'

/**
 * @summary Register Affiliate
 */
export const registerAffiliate = (
  affiliateRegisterRequest: AffiliateRegisterRequest,
  signal?: AbortSignal,
) => {
  return registerAffiliateMutator<AffiliateRegisterResponse>({
    url: `/v4/affiliates/register/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: affiliateRegisterRequest,
    signal,
  })
}

export const getRegisterAffiliateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerAffiliate>>,
    TError,
    { data: AffiliateRegisterRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerAffiliate>>,
  TError,
  { data: AffiliateRegisterRequest },
  TContext
> => {
  const mutationKey = ['registerAffiliate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerAffiliate>>,
    { data: AffiliateRegisterRequest }
  > = (props) => {
    const { data } = props ?? {}

    return registerAffiliate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type RegisterAffiliateMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerAffiliate>>
>
export type RegisterAffiliateMutationBody = AffiliateRegisterRequest
export type RegisterAffiliateMutationError = unknown

/**
 * @summary Register Affiliate
 */
export const useRegisterAffiliate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof registerAffiliate>>,
      TError,
      { data: AffiliateRegisterRequest },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof registerAffiliate>>,
  TError,
  { data: AffiliateRegisterRequest },
  TContext
> => {
  const mutationOptions = getRegisterAffiliateMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Register Affiliate Public
 */
export const registerAffiliatePublic = (
  affiliateRegisterRequest: AffiliateRegisterRequest,
  signal?: AbortSignal,
) => {
  return registerAffiliatePublicMutator<AffiliateRegisterResponse>({
    url: `/v4/affiliates/register/public/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: affiliateRegisterRequest,
    signal,
  })
}

export const getRegisterAffiliatePublicMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerAffiliatePublic>>,
    TError,
    { data: AffiliateRegisterRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerAffiliatePublic>>,
  TError,
  { data: AffiliateRegisterRequest },
  TContext
> => {
  const mutationKey = ['registerAffiliatePublic']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerAffiliatePublic>>,
    { data: AffiliateRegisterRequest }
  > = (props) => {
    const { data } = props ?? {}

    return registerAffiliatePublic(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type RegisterAffiliatePublicMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerAffiliatePublic>>
>
export type RegisterAffiliatePublicMutationBody = AffiliateRegisterRequest
export type RegisterAffiliatePublicMutationError = unknown

/**
 * @summary Register Affiliate Public
 */
export const useRegisterAffiliatePublic = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof registerAffiliatePublic>>,
      TError,
      { data: AffiliateRegisterRequest },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof registerAffiliatePublic>>,
  TError,
  { data: AffiliateRegisterRequest },
  TContext
> => {
  const mutationOptions = getRegisterAffiliatePublicMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Get My Profile
 */
export const getMyProfile = (signal?: AbortSignal) => {
  return getMyProfileMutator<AffiliatePartnerProfileSchema>({
    url: `/v4/affiliates/me/`,
    method: 'GET',
    signal,
  })
}

export const getGetMyProfileQueryKey = () => {
  return [`/v4/affiliates/me/`] as const
}

export const getGetMyProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetMyProfileQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyProfile>>> = ({ signal }) =>
    getMyProfile(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getMyProfile>>>
export type GetMyProfileQueryError = unknown

export function useGetMyProfile<TData = Awaited<ReturnType<typeof getMyProfile>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyProfile>>,
          TError,
          Awaited<ReturnType<typeof getMyProfile>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyProfile<TData = Awaited<ReturnType<typeof getMyProfile>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyProfile>>,
          TError,
          Awaited<ReturnType<typeof getMyProfile>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyProfile<TData = Awaited<ReturnType<typeof getMyProfile>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Profile
 */

export function useGetMyProfile<TData = Awaited<ReturnType<typeof getMyProfile>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyProfileQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getGetMyProfileSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetMyProfileQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyProfile>>> = ({ signal }) =>
    getMyProfile(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMyProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyProfileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMyProfile>>>
export type GetMyProfileSuspenseQueryError = unknown

export function useGetMyProfileSuspense<
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyProfileSuspense<
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyProfileSuspense<
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Profile
 */

export function useGetMyProfileSuspense<
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyProfileSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Update My Profile
 */
export const updateMyProfile = (affiliateUpdateProfileSchema: AffiliateUpdateProfileSchema) => {
  return updateMyProfileMutator<AffiliatePartnerProfileSchema>({
    url: `/v4/affiliates/me/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: affiliateUpdateProfileSchema,
  })
}

export const getUpdateMyProfileMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyProfile>>,
    TError,
    { data: AffiliateUpdateProfileSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyProfile>>,
  TError,
  { data: AffiliateUpdateProfileSchema },
  TContext
> => {
  const mutationKey = ['updateMyProfile']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyProfile>>,
    { data: AffiliateUpdateProfileSchema }
  > = (props) => {
    const { data } = props ?? {}

    return updateMyProfile(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateMyProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateMyProfile>>>
export type UpdateMyProfileMutationBody = AffiliateUpdateProfileSchema
export type UpdateMyProfileMutationError = unknown

/**
 * @summary Update My Profile
 */
export const useUpdateMyProfile = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMyProfile>>,
      TError,
      { data: AffiliateUpdateProfileSchema },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMyProfile>>,
  TError,
  { data: AffiliateUpdateProfileSchema },
  TContext
> => {
  const mutationOptions = getUpdateMyProfileMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Accept My Terms
 */
export const acceptMyTerms = (signal?: AbortSignal) => {
  return acceptMyTermsMutator<AffiliatePartnerProfileSchema>({
    url: `/v4/affiliates/me/terms/`,
    method: 'POST',
    signal,
  })
}

export const getAcceptMyTermsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof acceptMyTerms>>, TError, void, TContext>
}): UseMutationOptions<Awaited<ReturnType<typeof acceptMyTerms>>, TError, void, TContext> => {
  const mutationKey = ['acceptMyTerms']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptMyTerms>>, void> = () => {
    return acceptMyTerms()
  }

  return { mutationFn, ...mutationOptions }
}

export type AcceptMyTermsMutationResult = NonNullable<Awaited<ReturnType<typeof acceptMyTerms>>>

export type AcceptMyTermsMutationError = unknown

/**
 * @summary Accept My Terms
 */
export const useAcceptMyTerms = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof acceptMyTerms>>, TError, void, TContext>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof acceptMyTerms>>, TError, void, TContext> => {
  const mutationOptions = getAcceptMyTermsMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Update Payment Method
 */
export const updatePaymentMethod = (
  affiliatePaymentMethodRequestSchema: AffiliatePaymentMethodRequestSchema,
) => {
  return updatePaymentMethodMutator<AffiliatePaymentMethodResponseSchema>({
    url: `/v4/affiliates/me/payment-method/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: affiliatePaymentMethodRequestSchema,
  })
}

export const getUpdatePaymentMethodMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePaymentMethod>>,
    TError,
    { data: AffiliatePaymentMethodRequestSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePaymentMethod>>,
  TError,
  { data: AffiliatePaymentMethodRequestSchema },
  TContext
> => {
  const mutationKey = ['updatePaymentMethod']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePaymentMethod>>,
    { data: AffiliatePaymentMethodRequestSchema }
  > = (props) => {
    const { data } = props ?? {}

    return updatePaymentMethod(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdatePaymentMethodMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePaymentMethod>>
>
export type UpdatePaymentMethodMutationBody = AffiliatePaymentMethodRequestSchema
export type UpdatePaymentMethodMutationError = unknown

/**
 * @summary Update Payment Method
 */
export const useUpdatePaymentMethod = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePaymentMethod>>,
      TError,
      { data: AffiliatePaymentMethodRequestSchema },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePaymentMethod>>,
  TError,
  { data: AffiliatePaymentMethodRequestSchema },
  TContext
> => {
  const mutationOptions = getUpdatePaymentMethodMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Get My Stats
 */
export const getMyStats = (signal?: AbortSignal) => {
  return getMyStatsMutator<AffiliatePartnerStatsSchema>({
    url: `/v4/affiliates/me/stats/`,
    method: 'GET',
    signal,
  })
}

export const getGetMyStatsQueryKey = () => {
  return [`/v4/affiliates/me/stats/`] as const
}

export const getGetMyStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyStats>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetMyStatsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyStats>>> = ({ signal }) =>
    getMyStats(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyStats>>>
export type GetMyStatsQueryError = unknown

export function useGetMyStats<TData = Awaited<ReturnType<typeof getMyStats>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyStats>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyStats>>,
          TError,
          Awaited<ReturnType<typeof getMyStats>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyStats<TData = Awaited<ReturnType<typeof getMyStats>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyStats>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyStats>>,
          TError,
          Awaited<ReturnType<typeof getMyStats>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyStats<TData = Awaited<ReturnType<typeof getMyStats>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyStats>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Stats
 */

export function useGetMyStats<TData = Awaited<ReturnType<typeof getMyStats>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyStats>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyStatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getGetMyStatsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyStats>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetMyStatsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyStats>>> = ({ signal }) =>
    getMyStats(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMyStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyStatsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMyStats>>>
export type GetMyStatsSuspenseQueryError = unknown

export function useGetMyStatsSuspense<
  TData = Awaited<ReturnType<typeof getMyStats>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyStats>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyStatsSuspense<
  TData = Awaited<ReturnType<typeof getMyStats>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyStats>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyStatsSuspense<
  TData = Awaited<ReturnType<typeof getMyStats>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyStats>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Stats
 */

export function useGetMyStatsSuspense<
  TData = Awaited<ReturnType<typeof getMyStats>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyStats>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyStatsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get My Analytics
 */
export const getMyAnalytics = (params: GetMyAnalyticsParams, signal?: AbortSignal) => {
  return getMyAnalyticsMutator<AffiliateAnalyticsResponseSchema>({
    url: `/v4/affiliates/me/analytics/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getGetMyAnalyticsQueryKey = (params?: GetMyAnalyticsParams) => {
  return [`/v4/affiliates/me/analytics/`, ...(params ? [params] : [])] as const
}

export const getGetMyAnalyticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyAnalytics>>,
  TError = unknown,
>(
  params: GetMyAnalyticsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAnalytics>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetMyAnalyticsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyAnalytics>>> = ({ signal }) =>
    getMyAnalytics(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyAnalytics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyAnalytics>>>
export type GetMyAnalyticsQueryError = unknown

export function useGetMyAnalytics<
  TData = Awaited<ReturnType<typeof getMyAnalytics>>,
  TError = unknown,
>(
  params: GetMyAnalyticsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAnalytics>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getMyAnalytics>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyAnalytics<
  TData = Awaited<ReturnType<typeof getMyAnalytics>>,
  TError = unknown,
>(
  params: GetMyAnalyticsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAnalytics>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getMyAnalytics>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyAnalytics<
  TData = Awaited<ReturnType<typeof getMyAnalytics>>,
  TError = unknown,
>(
  params: GetMyAnalyticsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAnalytics>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Analytics
 */

export function useGetMyAnalytics<
  TData = Awaited<ReturnType<typeof getMyAnalytics>>,
  TError = unknown,
>(
  params: GetMyAnalyticsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAnalytics>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyAnalyticsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getGetMyAnalyticsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyAnalytics>>,
  TError = unknown,
>(
  params: GetMyAnalyticsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyAnalytics>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetMyAnalyticsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyAnalytics>>> = ({ signal }) =>
    getMyAnalytics(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMyAnalytics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyAnalyticsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyAnalytics>>
>
export type GetMyAnalyticsSuspenseQueryError = unknown

export function useGetMyAnalyticsSuspense<
  TData = Awaited<ReturnType<typeof getMyAnalytics>>,
  TError = unknown,
>(
  params: GetMyAnalyticsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyAnalytics>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyAnalyticsSuspense<
  TData = Awaited<ReturnType<typeof getMyAnalytics>>,
  TError = unknown,
>(
  params: GetMyAnalyticsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyAnalytics>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyAnalyticsSuspense<
  TData = Awaited<ReturnType<typeof getMyAnalytics>>,
  TError = unknown,
>(
  params: GetMyAnalyticsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyAnalytics>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Analytics
 */

export function useGetMyAnalyticsSuspense<
  TData = Awaited<ReturnType<typeof getMyAnalytics>>,
  TError = unknown,
>(
  params: GetMyAnalyticsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyAnalytics>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyAnalyticsSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get My Commissions
 */
export const getMyCommissions = (params?: GetMyCommissionsParams, signal?: AbortSignal) => {
  return getMyCommissionsMutator<PagedAffiliateCommissionSchema>({
    url: `/v4/affiliates/me/commissions/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getGetMyCommissionsQueryKey = (params?: GetMyCommissionsParams) => {
  return [`/v4/affiliates/me/commissions/`, ...(params ? [params] : [])] as const
}

export const getGetMyCommissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyCommissions>>,
  TError = unknown,
>(
  params?: GetMyCommissionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCommissions>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetMyCommissionsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCommissions>>> = ({ signal }) =>
    getMyCommissions(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyCommissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyCommissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyCommissions>>>
export type GetMyCommissionsQueryError = unknown

export function useGetMyCommissions<
  TData = Awaited<ReturnType<typeof getMyCommissions>>,
  TError = unknown,
>(
  params: undefined | GetMyCommissionsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCommissions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyCommissions>>,
          TError,
          Awaited<ReturnType<typeof getMyCommissions>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyCommissions<
  TData = Awaited<ReturnType<typeof getMyCommissions>>,
  TError = unknown,
>(
  params?: GetMyCommissionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCommissions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyCommissions>>,
          TError,
          Awaited<ReturnType<typeof getMyCommissions>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyCommissions<
  TData = Awaited<ReturnType<typeof getMyCommissions>>,
  TError = unknown,
>(
  params?: GetMyCommissionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCommissions>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Commissions
 */

export function useGetMyCommissions<
  TData = Awaited<ReturnType<typeof getMyCommissions>>,
  TError = unknown,
>(
  params?: GetMyCommissionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCommissions>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyCommissionsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getGetMyCommissionsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyCommissions>>,
  TError = unknown,
>(
  params?: GetMyCommissionsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyCommissions>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetMyCommissionsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCommissions>>> = ({ signal }) =>
    getMyCommissions(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMyCommissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyCommissionsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyCommissions>>
>
export type GetMyCommissionsSuspenseQueryError = unknown

export function useGetMyCommissionsSuspense<
  TData = Awaited<ReturnType<typeof getMyCommissions>>,
  TError = unknown,
>(
  params: undefined | GetMyCommissionsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyCommissions>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyCommissionsSuspense<
  TData = Awaited<ReturnType<typeof getMyCommissions>>,
  TError = unknown,
>(
  params?: GetMyCommissionsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyCommissions>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyCommissionsSuspense<
  TData = Awaited<ReturnType<typeof getMyCommissions>>,
  TError = unknown,
>(
  params?: GetMyCommissionsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyCommissions>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Commissions
 */

export function useGetMyCommissionsSuspense<
  TData = Awaited<ReturnType<typeof getMyCommissions>>,
  TError = unknown,
>(
  params?: GetMyCommissionsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyCommissions>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyCommissionsSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get My Coupons
 */
export const getMyCoupons = (signal?: AbortSignal) => {
  return getMyCouponsMutator<AffiliateCouponWithStatsSchema[]>({
    url: `/v4/affiliates/me/coupons/`,
    method: 'GET',
    signal,
  })
}

export const getGetMyCouponsQueryKey = () => {
  return [`/v4/affiliates/me/coupons/`] as const
}

export const getGetMyCouponsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyCoupons>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCoupons>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetMyCouponsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCoupons>>> = ({ signal }) =>
    getMyCoupons(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyCoupons>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyCouponsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyCoupons>>>
export type GetMyCouponsQueryError = unknown

export function useGetMyCoupons<TData = Awaited<ReturnType<typeof getMyCoupons>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCoupons>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyCoupons>>,
          TError,
          Awaited<ReturnType<typeof getMyCoupons>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyCoupons<TData = Awaited<ReturnType<typeof getMyCoupons>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCoupons>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyCoupons>>,
          TError,
          Awaited<ReturnType<typeof getMyCoupons>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyCoupons<TData = Awaited<ReturnType<typeof getMyCoupons>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCoupons>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Coupons
 */

export function useGetMyCoupons<TData = Awaited<ReturnType<typeof getMyCoupons>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCoupons>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyCouponsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getGetMyCouponsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyCoupons>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyCoupons>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetMyCouponsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCoupons>>> = ({ signal }) =>
    getMyCoupons(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMyCoupons>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyCouponsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMyCoupons>>>
export type GetMyCouponsSuspenseQueryError = unknown

export function useGetMyCouponsSuspense<
  TData = Awaited<ReturnType<typeof getMyCoupons>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyCoupons>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyCouponsSuspense<
  TData = Awaited<ReturnType<typeof getMyCoupons>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyCoupons>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyCouponsSuspense<
  TData = Awaited<ReturnType<typeof getMyCoupons>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyCoupons>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Coupons
 */

export function useGetMyCouponsSuspense<
  TData = Awaited<ReturnType<typeof getMyCoupons>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyCoupons>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyCouponsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Request Payout
 */
export const requestPayout = (signal?: AbortSignal) => {
  return requestPayoutMutator<AffiliatePayoutSchema>({
    url: `/v4/affiliates/me/payouts/`,
    method: 'POST',
    signal,
  })
}

export const getRequestPayoutMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof requestPayout>>, TError, void, TContext>
}): UseMutationOptions<Awaited<ReturnType<typeof requestPayout>>, TError, void, TContext> => {
  const mutationKey = ['requestPayout']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestPayout>>, void> = () => {
    return requestPayout()
  }

  return { mutationFn, ...mutationOptions }
}

export type RequestPayoutMutationResult = NonNullable<Awaited<ReturnType<typeof requestPayout>>>

export type RequestPayoutMutationError = unknown

/**
 * @summary Request Payout
 */
export const useRequestPayout = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof requestPayout>>, TError, void, TContext>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof requestPayout>>, TError, void, TContext> => {
  const mutationOptions = getRequestPayoutMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Get My Payouts
 */
export const getMyPayouts = (signal?: AbortSignal) => {
  return getMyPayoutsMutator<AffiliatePayoutSchema[]>({
    url: `/v4/affiliates/me/payouts/`,
    method: 'GET',
    signal,
  })
}

export const getGetMyPayoutsQueryKey = () => {
  return [`/v4/affiliates/me/payouts/`] as const
}

export const getGetMyPayoutsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyPayouts>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyPayouts>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetMyPayoutsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyPayouts>>> = ({ signal }) =>
    getMyPayouts(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyPayouts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyPayoutsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyPayouts>>>
export type GetMyPayoutsQueryError = unknown

export function useGetMyPayouts<TData = Awaited<ReturnType<typeof getMyPayouts>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyPayouts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyPayouts>>,
          TError,
          Awaited<ReturnType<typeof getMyPayouts>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyPayouts<TData = Awaited<ReturnType<typeof getMyPayouts>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyPayouts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyPayouts>>,
          TError,
          Awaited<ReturnType<typeof getMyPayouts>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyPayouts<TData = Awaited<ReturnType<typeof getMyPayouts>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyPayouts>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Payouts
 */

export function useGetMyPayouts<TData = Awaited<ReturnType<typeof getMyPayouts>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyPayouts>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyPayoutsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getGetMyPayoutsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyPayouts>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyPayouts>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetMyPayoutsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyPayouts>>> = ({ signal }) =>
    getMyPayouts(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMyPayouts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyPayoutsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMyPayouts>>>
export type GetMyPayoutsSuspenseQueryError = unknown

export function useGetMyPayoutsSuspense<
  TData = Awaited<ReturnType<typeof getMyPayouts>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyPayouts>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyPayoutsSuspense<
  TData = Awaited<ReturnType<typeof getMyPayouts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyPayouts>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyPayoutsSuspense<
  TData = Awaited<ReturnType<typeof getMyPayouts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyPayouts>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Payouts
 */

export function useGetMyPayoutsSuspense<
  TData = Awaited<ReturnType<typeof getMyPayouts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyPayouts>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyPayoutsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary List Partner Assets
 */
export const listPartnerAssets = (params?: ListPartnerAssetsParams, signal?: AbortSignal) => {
  return listPartnerAssetsMutator<AffiliatePartnerAssetSchema[]>({
    url: `/v4/affiliates/assets/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getListPartnerAssetsQueryKey = (params?: ListPartnerAssetsParams) => {
  return [`/v4/affiliates/assets/`, ...(params ? [params] : [])] as const
}

export const getListPartnerAssetsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPartnerAssets>>,
  TError = unknown,
>(
  params?: ListPartnerAssetsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPartnerAssets>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListPartnerAssetsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPartnerAssets>>> = ({ signal }) =>
    listPartnerAssets(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPartnerAssets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPartnerAssetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPartnerAssets>>
>
export type ListPartnerAssetsQueryError = unknown

export function useListPartnerAssets<
  TData = Awaited<ReturnType<typeof listPartnerAssets>>,
  TError = unknown,
>(
  params: undefined | ListPartnerAssetsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPartnerAssets>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPartnerAssets>>,
          TError,
          Awaited<ReturnType<typeof listPartnerAssets>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPartnerAssets<
  TData = Awaited<ReturnType<typeof listPartnerAssets>>,
  TError = unknown,
>(
  params?: ListPartnerAssetsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPartnerAssets>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPartnerAssets>>,
          TError,
          Awaited<ReturnType<typeof listPartnerAssets>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPartnerAssets<
  TData = Awaited<ReturnType<typeof listPartnerAssets>>,
  TError = unknown,
>(
  params?: ListPartnerAssetsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPartnerAssets>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Partner Assets
 */

export function useListPartnerAssets<
  TData = Awaited<ReturnType<typeof listPartnerAssets>>,
  TError = unknown,
>(
  params?: ListPartnerAssetsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPartnerAssets>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListPartnerAssetsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getListPartnerAssetsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listPartnerAssets>>,
  TError = unknown,
>(
  params?: ListPartnerAssetsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPartnerAssets>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListPartnerAssetsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPartnerAssets>>> = ({ signal }) =>
    listPartnerAssets(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listPartnerAssets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPartnerAssetsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPartnerAssets>>
>
export type ListPartnerAssetsSuspenseQueryError = unknown

export function useListPartnerAssetsSuspense<
  TData = Awaited<ReturnType<typeof listPartnerAssets>>,
  TError = unknown,
>(
  params: undefined | ListPartnerAssetsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPartnerAssets>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPartnerAssetsSuspense<
  TData = Awaited<ReturnType<typeof listPartnerAssets>>,
  TError = unknown,
>(
  params?: ListPartnerAssetsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPartnerAssets>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPartnerAssetsSuspense<
  TData = Awaited<ReturnType<typeof listPartnerAssets>>,
  TError = unknown,
>(
  params?: ListPartnerAssetsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPartnerAssets>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Partner Assets
 */

export function useListPartnerAssetsSuspense<
  TData = Awaited<ReturnType<typeof listPartnerAssets>>,
  TError = unknown,
>(
  params?: ListPartnerAssetsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPartnerAssets>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListPartnerAssetsSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Program Stats View
 */
export const getProgramStatsView = (params?: GetProgramStatsViewParams, signal?: AbortSignal) => {
  return getProgramStatsViewMutator<AffiliateProgramStatsSchema>({
    url: `/v4/affiliates/admin/dashboard/stats/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getGetProgramStatsViewQueryKey = (params?: GetProgramStatsViewParams) => {
  return [`/v4/affiliates/admin/dashboard/stats/`, ...(params ? [params] : [])] as const
}

export const getGetProgramStatsViewQueryOptions = <
  TData = Awaited<ReturnType<typeof getProgramStatsView>>,
  TError = unknown,
>(
  params?: GetProgramStatsViewParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProgramStatsView>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetProgramStatsViewQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProgramStatsView>>> = ({ signal }) =>
    getProgramStatsView(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProgramStatsView>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProgramStatsViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProgramStatsView>>
>
export type GetProgramStatsViewQueryError = unknown

export function useGetProgramStatsView<
  TData = Awaited<ReturnType<typeof getProgramStatsView>>,
  TError = unknown,
>(
  params: undefined | GetProgramStatsViewParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProgramStatsView>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProgramStatsView>>,
          TError,
          Awaited<ReturnType<typeof getProgramStatsView>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProgramStatsView<
  TData = Awaited<ReturnType<typeof getProgramStatsView>>,
  TError = unknown,
>(
  params?: GetProgramStatsViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProgramStatsView>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProgramStatsView>>,
          TError,
          Awaited<ReturnType<typeof getProgramStatsView>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProgramStatsView<
  TData = Awaited<ReturnType<typeof getProgramStatsView>>,
  TError = unknown,
>(
  params?: GetProgramStatsViewParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProgramStatsView>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Program Stats View
 */

export function useGetProgramStatsView<
  TData = Awaited<ReturnType<typeof getProgramStatsView>>,
  TError = unknown,
>(
  params?: GetProgramStatsViewParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProgramStatsView>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProgramStatsViewQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getGetProgramStatsViewSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getProgramStatsView>>,
  TError = unknown,
>(
  params?: GetProgramStatsViewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgramStatsView>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetProgramStatsViewQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProgramStatsView>>> = ({ signal }) =>
    getProgramStatsView(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getProgramStatsView>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProgramStatsViewSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProgramStatsView>>
>
export type GetProgramStatsViewSuspenseQueryError = unknown

export function useGetProgramStatsViewSuspense<
  TData = Awaited<ReturnType<typeof getProgramStatsView>>,
  TError = unknown,
>(
  params: undefined | GetProgramStatsViewParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgramStatsView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProgramStatsViewSuspense<
  TData = Awaited<ReturnType<typeof getProgramStatsView>>,
  TError = unknown,
>(
  params?: GetProgramStatsViewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgramStatsView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProgramStatsViewSuspense<
  TData = Awaited<ReturnType<typeof getProgramStatsView>>,
  TError = unknown,
>(
  params?: GetProgramStatsViewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgramStatsView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Program Stats View
 */

export function useGetProgramStatsViewSuspense<
  TData = Awaited<ReturnType<typeof getProgramStatsView>>,
  TError = unknown,
>(
  params?: GetProgramStatsViewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgramStatsView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProgramStatsViewSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Program Leaderboard View
 */
export const getProgramLeaderboardView = (
  params: GetProgramLeaderboardViewParams,
  signal?: AbortSignal,
) => {
  return getProgramLeaderboardViewMutator<AffiliatePartnerLeaderboardResponseSchema>({
    url: `/v4/affiliates/admin/dashboard/leaderboard/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getGetProgramLeaderboardViewQueryKey = (params?: GetProgramLeaderboardViewParams) => {
  return [`/v4/affiliates/admin/dashboard/leaderboard/`, ...(params ? [params] : [])] as const
}

export const getGetProgramLeaderboardViewQueryOptions = <
  TData = Awaited<ReturnType<typeof getProgramLeaderboardView>>,
  TError = unknown,
>(
  params: GetProgramLeaderboardViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProgramLeaderboardView>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetProgramLeaderboardViewQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProgramLeaderboardView>>> = ({
    signal,
  }) => getProgramLeaderboardView(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProgramLeaderboardView>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProgramLeaderboardViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProgramLeaderboardView>>
>
export type GetProgramLeaderboardViewQueryError = unknown

export function useGetProgramLeaderboardView<
  TData = Awaited<ReturnType<typeof getProgramLeaderboardView>>,
  TError = unknown,
>(
  params: GetProgramLeaderboardViewParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProgramLeaderboardView>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProgramLeaderboardView>>,
          TError,
          Awaited<ReturnType<typeof getProgramLeaderboardView>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProgramLeaderboardView<
  TData = Awaited<ReturnType<typeof getProgramLeaderboardView>>,
  TError = unknown,
>(
  params: GetProgramLeaderboardViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProgramLeaderboardView>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProgramLeaderboardView>>,
          TError,
          Awaited<ReturnType<typeof getProgramLeaderboardView>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProgramLeaderboardView<
  TData = Awaited<ReturnType<typeof getProgramLeaderboardView>>,
  TError = unknown,
>(
  params: GetProgramLeaderboardViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProgramLeaderboardView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Program Leaderboard View
 */

export function useGetProgramLeaderboardView<
  TData = Awaited<ReturnType<typeof getProgramLeaderboardView>>,
  TError = unknown,
>(
  params: GetProgramLeaderboardViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProgramLeaderboardView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProgramLeaderboardViewQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getGetProgramLeaderboardViewSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getProgramLeaderboardView>>,
  TError = unknown,
>(
  params: GetProgramLeaderboardViewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgramLeaderboardView>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetProgramLeaderboardViewQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProgramLeaderboardView>>> = ({
    signal,
  }) => getProgramLeaderboardView(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getProgramLeaderboardView>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProgramLeaderboardViewSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProgramLeaderboardView>>
>
export type GetProgramLeaderboardViewSuspenseQueryError = unknown

export function useGetProgramLeaderboardViewSuspense<
  TData = Awaited<ReturnType<typeof getProgramLeaderboardView>>,
  TError = unknown,
>(
  params: GetProgramLeaderboardViewParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgramLeaderboardView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProgramLeaderboardViewSuspense<
  TData = Awaited<ReturnType<typeof getProgramLeaderboardView>>,
  TError = unknown,
>(
  params: GetProgramLeaderboardViewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgramLeaderboardView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProgramLeaderboardViewSuspense<
  TData = Awaited<ReturnType<typeof getProgramLeaderboardView>>,
  TError = unknown,
>(
  params: GetProgramLeaderboardViewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgramLeaderboardView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Program Leaderboard View
 */

export function useGetProgramLeaderboardViewSuspense<
  TData = Awaited<ReturnType<typeof getProgramLeaderboardView>>,
  TError = unknown,
>(
  params: GetProgramLeaderboardViewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgramLeaderboardView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProgramLeaderboardViewSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Next Batch View
 */
export const getNextBatchView = (signal?: AbortSignal) => {
  return getNextBatchViewMutator<AffiliateNextBatchResponseSchema>({
    url: `/v4/affiliates/admin/dashboard/next-batch/`,
    method: 'GET',
    signal,
  })
}

export const getGetNextBatchViewQueryKey = () => {
  return [`/v4/affiliates/admin/dashboard/next-batch/`] as const
}

export const getGetNextBatchViewQueryOptions = <
  TData = Awaited<ReturnType<typeof getNextBatchView>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextBatchView>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetNextBatchViewQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNextBatchView>>> = ({ signal }) =>
    getNextBatchView(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNextBatchView>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNextBatchViewQueryResult = NonNullable<Awaited<ReturnType<typeof getNextBatchView>>>
export type GetNextBatchViewQueryError = unknown

export function useGetNextBatchView<
  TData = Awaited<ReturnType<typeof getNextBatchView>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextBatchView>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNextBatchView>>,
          TError,
          Awaited<ReturnType<typeof getNextBatchView>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNextBatchView<
  TData = Awaited<ReturnType<typeof getNextBatchView>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextBatchView>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNextBatchView>>,
          TError,
          Awaited<ReturnType<typeof getNextBatchView>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNextBatchView<
  TData = Awaited<ReturnType<typeof getNextBatchView>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextBatchView>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Next Batch View
 */

export function useGetNextBatchView<
  TData = Awaited<ReturnType<typeof getNextBatchView>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextBatchView>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNextBatchViewQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getGetNextBatchViewSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getNextBatchView>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNextBatchView>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetNextBatchViewQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNextBatchView>>> = ({ signal }) =>
    getNextBatchView(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getNextBatchView>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNextBatchViewSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNextBatchView>>
>
export type GetNextBatchViewSuspenseQueryError = unknown

export function useGetNextBatchViewSuspense<
  TData = Awaited<ReturnType<typeof getNextBatchView>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNextBatchView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNextBatchViewSuspense<
  TData = Awaited<ReturnType<typeof getNextBatchView>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNextBatchView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNextBatchViewSuspense<
  TData = Awaited<ReturnType<typeof getNextBatchView>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNextBatchView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Next Batch View
 */

export function useGetNextBatchViewSuspense<
  TData = Awaited<ReturnType<typeof getNextBatchView>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNextBatchView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNextBatchViewSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Program Analytics View
 */
export const getProgramAnalyticsView = (
  params: GetProgramAnalyticsViewParams,
  signal?: AbortSignal,
) => {
  return getProgramAnalyticsViewMutator<AffiliateAnalyticsResponseSchema>({
    url: `/v4/affiliates/admin/dashboard/analytics/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getGetProgramAnalyticsViewQueryKey = (params?: GetProgramAnalyticsViewParams) => {
  return [`/v4/affiliates/admin/dashboard/analytics/`, ...(params ? [params] : [])] as const
}

export const getGetProgramAnalyticsViewQueryOptions = <
  TData = Awaited<ReturnType<typeof getProgramAnalyticsView>>,
  TError = unknown,
>(
  params: GetProgramAnalyticsViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProgramAnalyticsView>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetProgramAnalyticsViewQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProgramAnalyticsView>>> = ({
    signal,
  }) => getProgramAnalyticsView(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProgramAnalyticsView>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProgramAnalyticsViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProgramAnalyticsView>>
>
export type GetProgramAnalyticsViewQueryError = unknown

export function useGetProgramAnalyticsView<
  TData = Awaited<ReturnType<typeof getProgramAnalyticsView>>,
  TError = unknown,
>(
  params: GetProgramAnalyticsViewParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProgramAnalyticsView>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProgramAnalyticsView>>,
          TError,
          Awaited<ReturnType<typeof getProgramAnalyticsView>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProgramAnalyticsView<
  TData = Awaited<ReturnType<typeof getProgramAnalyticsView>>,
  TError = unknown,
>(
  params: GetProgramAnalyticsViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProgramAnalyticsView>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProgramAnalyticsView>>,
          TError,
          Awaited<ReturnType<typeof getProgramAnalyticsView>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProgramAnalyticsView<
  TData = Awaited<ReturnType<typeof getProgramAnalyticsView>>,
  TError = unknown,
>(
  params: GetProgramAnalyticsViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProgramAnalyticsView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Program Analytics View
 */

export function useGetProgramAnalyticsView<
  TData = Awaited<ReturnType<typeof getProgramAnalyticsView>>,
  TError = unknown,
>(
  params: GetProgramAnalyticsViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProgramAnalyticsView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProgramAnalyticsViewQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getGetProgramAnalyticsViewSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getProgramAnalyticsView>>,
  TError = unknown,
>(
  params: GetProgramAnalyticsViewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgramAnalyticsView>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetProgramAnalyticsViewQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProgramAnalyticsView>>> = ({
    signal,
  }) => getProgramAnalyticsView(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getProgramAnalyticsView>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProgramAnalyticsViewSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProgramAnalyticsView>>
>
export type GetProgramAnalyticsViewSuspenseQueryError = unknown

export function useGetProgramAnalyticsViewSuspense<
  TData = Awaited<ReturnType<typeof getProgramAnalyticsView>>,
  TError = unknown,
>(
  params: GetProgramAnalyticsViewParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgramAnalyticsView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProgramAnalyticsViewSuspense<
  TData = Awaited<ReturnType<typeof getProgramAnalyticsView>>,
  TError = unknown,
>(
  params: GetProgramAnalyticsViewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgramAnalyticsView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProgramAnalyticsViewSuspense<
  TData = Awaited<ReturnType<typeof getProgramAnalyticsView>>,
  TError = unknown,
>(
  params: GetProgramAnalyticsViewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgramAnalyticsView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Program Analytics View
 */

export function useGetProgramAnalyticsViewSuspense<
  TData = Awaited<ReturnType<typeof getProgramAnalyticsView>>,
  TError = unknown,
>(
  params: GetProgramAnalyticsViewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgramAnalyticsView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProgramAnalyticsViewSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary List Partners
 */
export const listPartners = (params?: ListPartnersParams, signal?: AbortSignal) => {
  return listPartnersMutator<AffiliateAdminPartnerListResponseSchema>({
    url: `/v4/affiliates/admin/partners/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getListPartnersQueryKey = (params?: ListPartnersParams) => {
  return [`/v4/affiliates/admin/partners/`, ...(params ? [params] : [])] as const
}

export const getListPartnersQueryOptions = <
  TData = Awaited<ReturnType<typeof listPartners>>,
  TError = unknown,
>(
  params?: ListPartnersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPartners>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListPartnersQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPartners>>> = ({ signal }) =>
    listPartners(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPartners>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPartnersQueryResult = NonNullable<Awaited<ReturnType<typeof listPartners>>>
export type ListPartnersQueryError = unknown

export function useListPartners<TData = Awaited<ReturnType<typeof listPartners>>, TError = unknown>(
  params: undefined | ListPartnersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPartners>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPartners>>,
          TError,
          Awaited<ReturnType<typeof listPartners>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPartners<TData = Awaited<ReturnType<typeof listPartners>>, TError = unknown>(
  params?: ListPartnersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPartners>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPartners>>,
          TError,
          Awaited<ReturnType<typeof listPartners>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPartners<TData = Awaited<ReturnType<typeof listPartners>>, TError = unknown>(
  params?: ListPartnersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPartners>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Partners
 */

export function useListPartners<TData = Awaited<ReturnType<typeof listPartners>>, TError = unknown>(
  params?: ListPartnersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPartners>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListPartnersQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getListPartnersSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listPartners>>,
  TError = unknown,
>(
  params?: ListPartnersParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPartners>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListPartnersQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPartners>>> = ({ signal }) =>
    listPartners(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listPartners>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPartnersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listPartners>>>
export type ListPartnersSuspenseQueryError = unknown

export function useListPartnersSuspense<
  TData = Awaited<ReturnType<typeof listPartners>>,
  TError = unknown,
>(
  params: undefined | ListPartnersParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPartners>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPartnersSuspense<
  TData = Awaited<ReturnType<typeof listPartners>>,
  TError = unknown,
>(
  params?: ListPartnersParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPartners>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPartnersSuspense<
  TData = Awaited<ReturnType<typeof listPartners>>,
  TError = unknown,
>(
  params?: ListPartnersParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPartners>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Partners
 */

export function useListPartnersSuspense<
  TData = Awaited<ReturnType<typeof listPartners>>,
  TError = unknown,
>(
  params?: ListPartnersParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPartners>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListPartnersSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Partner
 */
export const getPartner = (partnerId: string, signal?: AbortSignal) => {
  return getPartnerMutator<AffiliateAdminPartnerDetailSchema>({
    url: `/v4/affiliates/admin/partners/${partnerId}/`,
    method: 'GET',
    signal,
  })
}

export const getGetPartnerQueryKey = (partnerId?: string) => {
  return [`/v4/affiliates/admin/partners/${partnerId}/`] as const
}

export const getGetPartnerQueryOptions = <
  TData = Awaited<ReturnType<typeof getPartner>>,
  TError = unknown,
>(
  partnerId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPartnerQueryKey(partnerId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartner>>> = ({ signal }) =>
    getPartner(partnerId, signal)

  return { queryKey, queryFn, enabled: !!partnerId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPartner>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPartnerQueryResult = NonNullable<Awaited<ReturnType<typeof getPartner>>>
export type GetPartnerQueryError = unknown

export function useGetPartner<TData = Awaited<ReturnType<typeof getPartner>>, TError = unknown>(
  partnerId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartner>>,
          TError,
          Awaited<ReturnType<typeof getPartner>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartner<TData = Awaited<ReturnType<typeof getPartner>>, TError = unknown>(
  partnerId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartner>>,
          TError,
          Awaited<ReturnType<typeof getPartner>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartner<TData = Awaited<ReturnType<typeof getPartner>>, TError = unknown>(
  partnerId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Partner
 */

export function useGetPartner<TData = Awaited<ReturnType<typeof getPartner>>, TError = unknown>(
  partnerId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPartnerQueryOptions(partnerId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getGetPartnerSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPartner>>,
  TError = unknown,
>(
  partnerId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPartnerQueryKey(partnerId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartner>>> = ({ signal }) =>
    getPartner(partnerId, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPartner>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPartnerSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPartner>>>
export type GetPartnerSuspenseQueryError = unknown

export function useGetPartnerSuspense<
  TData = Awaited<ReturnType<typeof getPartner>>,
  TError = unknown,
>(
  partnerId: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnerSuspense<
  TData = Awaited<ReturnType<typeof getPartner>>,
  TError = unknown,
>(
  partnerId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnerSuspense<
  TData = Awaited<ReturnType<typeof getPartner>>,
  TError = unknown,
>(
  partnerId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Partner
 */

export function useGetPartnerSuspense<
  TData = Awaited<ReturnType<typeof getPartner>>,
  TError = unknown,
>(
  partnerId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPartnerSuspenseQueryOptions(partnerId, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Update Partner
 */
export const updatePartner = (
  partnerId: string,
  affiliateAdminPartnerUpdateSchema: AffiliateAdminPartnerUpdateSchema,
) => {
  return updatePartnerMutator<AffiliateAdminPartnerDetailSchema>({
    url: `/v4/affiliates/admin/partners/${partnerId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: affiliateAdminPartnerUpdateSchema,
  })
}

export const getUpdatePartnerMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePartner>>,
    TError,
    { partnerId: string; data: AffiliateAdminPartnerUpdateSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePartner>>,
  TError,
  { partnerId: string; data: AffiliateAdminPartnerUpdateSchema },
  TContext
> => {
  const mutationKey = ['updatePartner']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePartner>>,
    { partnerId: string; data: AffiliateAdminPartnerUpdateSchema }
  > = (props) => {
    const { partnerId, data } = props ?? {}

    return updatePartner(partnerId, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdatePartnerMutationResult = NonNullable<Awaited<ReturnType<typeof updatePartner>>>
export type UpdatePartnerMutationBody = AffiliateAdminPartnerUpdateSchema
export type UpdatePartnerMutationError = unknown

/**
 * @summary Update Partner
 */
export const useUpdatePartner = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePartner>>,
      TError,
      { partnerId: string; data: AffiliateAdminPartnerUpdateSchema },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePartner>>,
  TError,
  { partnerId: string; data: AffiliateAdminPartnerUpdateSchema },
  TContext
> => {
  const mutationOptions = getUpdatePartnerMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Get Partner Stats View
 */
export const getPartnerStatsView = (
  partnerId: string,
  params?: GetPartnerStatsViewParams,
  signal?: AbortSignal,
) => {
  return getPartnerStatsViewMutator<AffiliatePartnerStatsSchema>({
    url: `/v4/affiliates/admin/partners/${partnerId}/stats/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getGetPartnerStatsViewQueryKey = (
  partnerId?: string,
  params?: GetPartnerStatsViewParams,
) => {
  return [`/v4/affiliates/admin/partners/${partnerId}/stats/`, ...(params ? [params] : [])] as const
}

export const getGetPartnerStatsViewQueryOptions = <
  TData = Awaited<ReturnType<typeof getPartnerStatsView>>,
  TError = unknown,
>(
  partnerId: string,
  params?: GetPartnerStatsViewParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnerStatsView>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPartnerStatsViewQueryKey(partnerId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartnerStatsView>>> = ({ signal }) =>
    getPartnerStatsView(partnerId, params, signal)

  return { queryKey, queryFn, enabled: !!partnerId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPartnerStatsView>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPartnerStatsViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPartnerStatsView>>
>
export type GetPartnerStatsViewQueryError = unknown

export function useGetPartnerStatsView<
  TData = Awaited<ReturnType<typeof getPartnerStatsView>>,
  TError = unknown,
>(
  partnerId: string,
  params: undefined | GetPartnerStatsViewParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerStatsView>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnerStatsView>>,
          TError,
          Awaited<ReturnType<typeof getPartnerStatsView>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnerStatsView<
  TData = Awaited<ReturnType<typeof getPartnerStatsView>>,
  TError = unknown,
>(
  partnerId: string,
  params?: GetPartnerStatsViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerStatsView>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnerStatsView>>,
          TError,
          Awaited<ReturnType<typeof getPartnerStatsView>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnerStatsView<
  TData = Awaited<ReturnType<typeof getPartnerStatsView>>,
  TError = unknown,
>(
  partnerId: string,
  params?: GetPartnerStatsViewParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnerStatsView>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Partner Stats View
 */

export function useGetPartnerStatsView<
  TData = Awaited<ReturnType<typeof getPartnerStatsView>>,
  TError = unknown,
>(
  partnerId: string,
  params?: GetPartnerStatsViewParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnerStatsView>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPartnerStatsViewQueryOptions(partnerId, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getGetPartnerStatsViewSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPartnerStatsView>>,
  TError = unknown,
>(
  partnerId: string,
  params?: GetPartnerStatsViewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPartnerStatsView>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPartnerStatsViewQueryKey(partnerId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartnerStatsView>>> = ({ signal }) =>
    getPartnerStatsView(partnerId, params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPartnerStatsView>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPartnerStatsViewSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPartnerStatsView>>
>
export type GetPartnerStatsViewSuspenseQueryError = unknown

export function useGetPartnerStatsViewSuspense<
  TData = Awaited<ReturnType<typeof getPartnerStatsView>>,
  TError = unknown,
>(
  partnerId: string,
  params: undefined | GetPartnerStatsViewParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPartnerStatsView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnerStatsViewSuspense<
  TData = Awaited<ReturnType<typeof getPartnerStatsView>>,
  TError = unknown,
>(
  partnerId: string,
  params?: GetPartnerStatsViewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPartnerStatsView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnerStatsViewSuspense<
  TData = Awaited<ReturnType<typeof getPartnerStatsView>>,
  TError = unknown,
>(
  partnerId: string,
  params?: GetPartnerStatsViewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPartnerStatsView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Partner Stats View
 */

export function useGetPartnerStatsViewSuspense<
  TData = Awaited<ReturnType<typeof getPartnerStatsView>>,
  TError = unknown,
>(
  partnerId: string,
  params?: GetPartnerStatsViewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPartnerStatsView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPartnerStatsViewSuspenseQueryOptions(partnerId, params, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Partner Analytics View
 */
export const getPartnerAnalyticsView = (
  partnerId: string,
  params: GetPartnerAnalyticsViewParams,
  signal?: AbortSignal,
) => {
  return getPartnerAnalyticsViewMutator<AffiliateAnalyticsResponseSchema>({
    url: `/v4/affiliates/admin/partners/${partnerId}/analytics/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getGetPartnerAnalyticsViewQueryKey = (
  partnerId?: string,
  params?: GetPartnerAnalyticsViewParams,
) => {
  return [
    `/v4/affiliates/admin/partners/${partnerId}/analytics/`,
    ...(params ? [params] : []),
  ] as const
}

export const getGetPartnerAnalyticsViewQueryOptions = <
  TData = Awaited<ReturnType<typeof getPartnerAnalyticsView>>,
  TError = unknown,
>(
  partnerId: string,
  params: GetPartnerAnalyticsViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerAnalyticsView>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPartnerAnalyticsViewQueryKey(partnerId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartnerAnalyticsView>>> = ({
    signal,
  }) => getPartnerAnalyticsView(partnerId, params, signal)

  return { queryKey, queryFn, enabled: !!partnerId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPartnerAnalyticsView>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPartnerAnalyticsViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPartnerAnalyticsView>>
>
export type GetPartnerAnalyticsViewQueryError = unknown

export function useGetPartnerAnalyticsView<
  TData = Awaited<ReturnType<typeof getPartnerAnalyticsView>>,
  TError = unknown,
>(
  partnerId: string,
  params: GetPartnerAnalyticsViewParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerAnalyticsView>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnerAnalyticsView>>,
          TError,
          Awaited<ReturnType<typeof getPartnerAnalyticsView>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnerAnalyticsView<
  TData = Awaited<ReturnType<typeof getPartnerAnalyticsView>>,
  TError = unknown,
>(
  partnerId: string,
  params: GetPartnerAnalyticsViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerAnalyticsView>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnerAnalyticsView>>,
          TError,
          Awaited<ReturnType<typeof getPartnerAnalyticsView>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnerAnalyticsView<
  TData = Awaited<ReturnType<typeof getPartnerAnalyticsView>>,
  TError = unknown,
>(
  partnerId: string,
  params: GetPartnerAnalyticsViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerAnalyticsView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Partner Analytics View
 */

export function useGetPartnerAnalyticsView<
  TData = Awaited<ReturnType<typeof getPartnerAnalyticsView>>,
  TError = unknown,
>(
  partnerId: string,
  params: GetPartnerAnalyticsViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerAnalyticsView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPartnerAnalyticsViewQueryOptions(partnerId, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getGetPartnerAnalyticsViewSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPartnerAnalyticsView>>,
  TError = unknown,
>(
  partnerId: string,
  params: GetPartnerAnalyticsViewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPartnerAnalyticsView>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPartnerAnalyticsViewQueryKey(partnerId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartnerAnalyticsView>>> = ({
    signal,
  }) => getPartnerAnalyticsView(partnerId, params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPartnerAnalyticsView>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPartnerAnalyticsViewSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPartnerAnalyticsView>>
>
export type GetPartnerAnalyticsViewSuspenseQueryError = unknown

export function useGetPartnerAnalyticsViewSuspense<
  TData = Awaited<ReturnType<typeof getPartnerAnalyticsView>>,
  TError = unknown,
>(
  partnerId: string,
  params: GetPartnerAnalyticsViewParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPartnerAnalyticsView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnerAnalyticsViewSuspense<
  TData = Awaited<ReturnType<typeof getPartnerAnalyticsView>>,
  TError = unknown,
>(
  partnerId: string,
  params: GetPartnerAnalyticsViewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPartnerAnalyticsView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnerAnalyticsViewSuspense<
  TData = Awaited<ReturnType<typeof getPartnerAnalyticsView>>,
  TError = unknown,
>(
  partnerId: string,
  params: GetPartnerAnalyticsViewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPartnerAnalyticsView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Partner Analytics View
 */

export function useGetPartnerAnalyticsViewSuspense<
  TData = Awaited<ReturnType<typeof getPartnerAnalyticsView>>,
  TError = unknown,
>(
  partnerId: string,
  params: GetPartnerAnalyticsViewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPartnerAnalyticsView>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPartnerAnalyticsViewSuspenseQueryOptions(partnerId, params, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Approve Partner
 */
export const approvePartner = (
  partnerId: string,
  approvePartnerBody?: ApprovePartnerBody,
  signal?: AbortSignal,
) => {
  return approvePartnerMutator<AffiliatePartnerStatusResponseSchema>({
    url: `/v4/affiliates/admin/partners/${partnerId}/approve/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: approvePartnerBody,
    signal,
  })
}

export const getApprovePartnerMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approvePartner>>,
    TError,
    { partnerId: string; data: ApprovePartnerBody },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof approvePartner>>,
  TError,
  { partnerId: string; data: ApprovePartnerBody },
  TContext
> => {
  const mutationKey = ['approvePartner']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approvePartner>>,
    { partnerId: string; data: ApprovePartnerBody }
  > = (props) => {
    const { partnerId, data } = props ?? {}

    return approvePartner(partnerId, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type ApprovePartnerMutationResult = NonNullable<Awaited<ReturnType<typeof approvePartner>>>
export type ApprovePartnerMutationBody = ApprovePartnerBody
export type ApprovePartnerMutationError = unknown

/**
 * @summary Approve Partner
 */
export const useApprovePartner = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof approvePartner>>,
      TError,
      { partnerId: string; data: ApprovePartnerBody },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof approvePartner>>,
  TError,
  { partnerId: string; data: ApprovePartnerBody },
  TContext
> => {
  const mutationOptions = getApprovePartnerMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Create Partner
 */
export const createPartner = (
  affiliateAdminCreatePartnerSchema: AffiliateAdminCreatePartnerSchema,
  signal?: AbortSignal,
) => {
  return createPartnerMutator<AffiliatePartnerStatusResponseSchema>({
    url: `/v4/affiliates/admin/partners/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: affiliateAdminCreatePartnerSchema,
    signal,
  })
}

export const getCreatePartnerMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPartner>>,
    TError,
    { data: AffiliateAdminCreatePartnerSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPartner>>,
  TError,
  { data: AffiliateAdminCreatePartnerSchema },
  TContext
> => {
  const mutationKey = ['createPartner']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPartner>>,
    { data: AffiliateAdminCreatePartnerSchema }
  > = (props) => {
    const { data } = props ?? {}

    return createPartner(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreatePartnerMutationResult = NonNullable<Awaited<ReturnType<typeof createPartner>>>
export type CreatePartnerMutationBody = AffiliateAdminCreatePartnerSchema
export type CreatePartnerMutationError = unknown

/**
 * @summary Create Partner
 */
export const useCreatePartner = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPartner>>,
      TError,
      { data: AffiliateAdminCreatePartnerSchema },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createPartner>>,
  TError,
  { data: AffiliateAdminCreatePartnerSchema },
  TContext
> => {
  const mutationOptions = getCreatePartnerMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Activate Partner
 */
export const activatePartner = (
  partnerId: string,
  affiliateActivatePartnerSchema: AffiliateActivatePartnerSchema,
  signal?: AbortSignal,
) => {
  return activatePartnerMutator<AffiliatePartnerStatusResponseSchema>({
    url: `/v4/affiliates/admin/partners/${partnerId}/activate/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: affiliateActivatePartnerSchema,
    signal,
  })
}

export const getActivatePartnerMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activatePartner>>,
    TError,
    { partnerId: string; data: AffiliateActivatePartnerSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof activatePartner>>,
  TError,
  { partnerId: string; data: AffiliateActivatePartnerSchema },
  TContext
> => {
  const mutationKey = ['activatePartner']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activatePartner>>,
    { partnerId: string; data: AffiliateActivatePartnerSchema }
  > = (props) => {
    const { partnerId, data } = props ?? {}

    return activatePartner(partnerId, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type ActivatePartnerMutationResult = NonNullable<Awaited<ReturnType<typeof activatePartner>>>
export type ActivatePartnerMutationBody = AffiliateActivatePartnerSchema
export type ActivatePartnerMutationError = unknown

/**
 * @summary Activate Partner
 */
export const useActivatePartner = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof activatePartner>>,
      TError,
      { partnerId: string; data: AffiliateActivatePartnerSchema },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof activatePartner>>,
  TError,
  { partnerId: string; data: AffiliateActivatePartnerSchema },
  TContext
> => {
  const mutationOptions = getActivatePartnerMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Reject Partner
 */
export const rejectPartner = (
  partnerId: string,
  affiliateRejectSuspendSchema: AffiliateRejectSuspendSchema,
  signal?: AbortSignal,
) => {
  return rejectPartnerMutator<AffiliatePartnerStatusResponseSchema>({
    url: `/v4/affiliates/admin/partners/${partnerId}/reject/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: affiliateRejectSuspendSchema,
    signal,
  })
}

export const getRejectPartnerMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectPartner>>,
    TError,
    { partnerId: string; data: AffiliateRejectSuspendSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectPartner>>,
  TError,
  { partnerId: string; data: AffiliateRejectSuspendSchema },
  TContext
> => {
  const mutationKey = ['rejectPartner']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectPartner>>,
    { partnerId: string; data: AffiliateRejectSuspendSchema }
  > = (props) => {
    const { partnerId, data } = props ?? {}

    return rejectPartner(partnerId, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type RejectPartnerMutationResult = NonNullable<Awaited<ReturnType<typeof rejectPartner>>>
export type RejectPartnerMutationBody = AffiliateRejectSuspendSchema
export type RejectPartnerMutationError = unknown

/**
 * @summary Reject Partner
 */
export const useRejectPartner = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rejectPartner>>,
      TError,
      { partnerId: string; data: AffiliateRejectSuspendSchema },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rejectPartner>>,
  TError,
  { partnerId: string; data: AffiliateRejectSuspendSchema },
  TContext
> => {
  const mutationOptions = getRejectPartnerMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Suspend Partner
 */
export const suspendPartner = (
  partnerId: string,
  affiliateRejectSuspendSchema: AffiliateRejectSuspendSchema,
  signal?: AbortSignal,
) => {
  return suspendPartnerMutator<AffiliatePartnerStatusResponseSchema>({
    url: `/v4/affiliates/admin/partners/${partnerId}/suspend/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: affiliateRejectSuspendSchema,
    signal,
  })
}

export const getSuspendPartnerMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof suspendPartner>>,
    TError,
    { partnerId: string; data: AffiliateRejectSuspendSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof suspendPartner>>,
  TError,
  { partnerId: string; data: AffiliateRejectSuspendSchema },
  TContext
> => {
  const mutationKey = ['suspendPartner']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof suspendPartner>>,
    { partnerId: string; data: AffiliateRejectSuspendSchema }
  > = (props) => {
    const { partnerId, data } = props ?? {}

    return suspendPartner(partnerId, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type SuspendPartnerMutationResult = NonNullable<Awaited<ReturnType<typeof suspendPartner>>>
export type SuspendPartnerMutationBody = AffiliateRejectSuspendSchema
export type SuspendPartnerMutationError = unknown

/**
 * @summary Suspend Partner
 */
export const useSuspendPartner = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof suspendPartner>>,
      TError,
      { partnerId: string; data: AffiliateRejectSuspendSchema },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof suspendPartner>>,
  TError,
  { partnerId: string; data: AffiliateRejectSuspendSchema },
  TContext
> => {
  const mutationOptions = getSuspendPartnerMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary List Partner Coupons
 */
export const listPartnerCoupons = (
  partnerId: string,
  params?: ListPartnerCouponsParams,
  signal?: AbortSignal,
) => {
  return listPartnerCouponsMutator<AffiliateAdminPartnerCouponListResponseSchema>({
    url: `/v4/affiliates/admin/partners/${partnerId}/coupons/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getListPartnerCouponsQueryKey = (
  partnerId?: string,
  params?: ListPartnerCouponsParams,
) => {
  return [
    `/v4/affiliates/admin/partners/${partnerId}/coupons/`,
    ...(params ? [params] : []),
  ] as const
}

export const getListPartnerCouponsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPartnerCoupons>>,
  TError = unknown,
>(
  partnerId: string,
  params?: ListPartnerCouponsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPartnerCoupons>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListPartnerCouponsQueryKey(partnerId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPartnerCoupons>>> = ({ signal }) =>
    listPartnerCoupons(partnerId, params, signal)

  return { queryKey, queryFn, enabled: !!partnerId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPartnerCoupons>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPartnerCouponsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPartnerCoupons>>
>
export type ListPartnerCouponsQueryError = unknown

export function useListPartnerCoupons<
  TData = Awaited<ReturnType<typeof listPartnerCoupons>>,
  TError = unknown,
>(
  partnerId: string,
  params: undefined | ListPartnerCouponsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPartnerCoupons>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPartnerCoupons>>,
          TError,
          Awaited<ReturnType<typeof listPartnerCoupons>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPartnerCoupons<
  TData = Awaited<ReturnType<typeof listPartnerCoupons>>,
  TError = unknown,
>(
  partnerId: string,
  params?: ListPartnerCouponsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listPartnerCoupons>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPartnerCoupons>>,
          TError,
          Awaited<ReturnType<typeof listPartnerCoupons>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPartnerCoupons<
  TData = Awaited<ReturnType<typeof listPartnerCoupons>>,
  TError = unknown,
>(
  partnerId: string,
  params?: ListPartnerCouponsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPartnerCoupons>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Partner Coupons
 */

export function useListPartnerCoupons<
  TData = Awaited<ReturnType<typeof listPartnerCoupons>>,
  TError = unknown,
>(
  partnerId: string,
  params?: ListPartnerCouponsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPartnerCoupons>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListPartnerCouponsQueryOptions(partnerId, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getListPartnerCouponsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listPartnerCoupons>>,
  TError = unknown,
>(
  partnerId: string,
  params?: ListPartnerCouponsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPartnerCoupons>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListPartnerCouponsQueryKey(partnerId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPartnerCoupons>>> = ({ signal }) =>
    listPartnerCoupons(partnerId, params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listPartnerCoupons>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPartnerCouponsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPartnerCoupons>>
>
export type ListPartnerCouponsSuspenseQueryError = unknown

export function useListPartnerCouponsSuspense<
  TData = Awaited<ReturnType<typeof listPartnerCoupons>>,
  TError = unknown,
>(
  partnerId: string,
  params: undefined | ListPartnerCouponsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPartnerCoupons>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPartnerCouponsSuspense<
  TData = Awaited<ReturnType<typeof listPartnerCoupons>>,
  TError = unknown,
>(
  partnerId: string,
  params?: ListPartnerCouponsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPartnerCoupons>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPartnerCouponsSuspense<
  TData = Awaited<ReturnType<typeof listPartnerCoupons>>,
  TError = unknown,
>(
  partnerId: string,
  params?: ListPartnerCouponsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPartnerCoupons>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Partner Coupons
 */

export function useListPartnerCouponsSuspense<
  TData = Awaited<ReturnType<typeof listPartnerCoupons>>,
  TError = unknown,
>(
  partnerId: string,
  params?: ListPartnerCouponsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPartnerCoupons>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListPartnerCouponsSuspenseQueryOptions(partnerId, params, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Create Coupon
 */
export const createCoupon = (
  partnerId: string,
  affiliateCreateCouponSchema: AffiliateCreateCouponSchema,
  signal?: AbortSignal,
) => {
  return createCouponMutator<AffiliateAdminCouponSchema>({
    url: `/v4/affiliates/admin/partners/${partnerId}/coupons/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: affiliateCreateCouponSchema,
    signal,
  })
}

export const getCreateCouponMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCoupon>>,
    TError,
    { partnerId: string; data: AffiliateCreateCouponSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCoupon>>,
  TError,
  { partnerId: string; data: AffiliateCreateCouponSchema },
  TContext
> => {
  const mutationKey = ['createCoupon']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCoupon>>,
    { partnerId: string; data: AffiliateCreateCouponSchema }
  > = (props) => {
    const { partnerId, data } = props ?? {}

    return createCoupon(partnerId, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateCouponMutationResult = NonNullable<Awaited<ReturnType<typeof createCoupon>>>
export type CreateCouponMutationBody = AffiliateCreateCouponSchema
export type CreateCouponMutationError = unknown

/**
 * @summary Create Coupon
 */
export const useCreateCoupon = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCoupon>>,
      TError,
      { partnerId: string; data: AffiliateCreateCouponSchema },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCoupon>>,
  TError,
  { partnerId: string; data: AffiliateCreateCouponSchema },
  TContext
> => {
  const mutationOptions = getCreateCouponMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Update Coupon
 */
export const updateCoupon = (
  partnerId: string,
  couponId: string,
  affiliateUpdateCouponSchema: AffiliateUpdateCouponSchema,
) => {
  return updateCouponMutator<AffiliateAdminCouponSchema>({
    url: `/v4/affiliates/admin/partners/${partnerId}/coupons/${couponId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: affiliateUpdateCouponSchema,
  })
}

export const getUpdateCouponMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCoupon>>,
    TError,
    { partnerId: string; couponId: string; data: AffiliateUpdateCouponSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCoupon>>,
  TError,
  { partnerId: string; couponId: string; data: AffiliateUpdateCouponSchema },
  TContext
> => {
  const mutationKey = ['updateCoupon']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCoupon>>,
    { partnerId: string; couponId: string; data: AffiliateUpdateCouponSchema }
  > = (props) => {
    const { partnerId, couponId, data } = props ?? {}

    return updateCoupon(partnerId, couponId, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateCouponMutationResult = NonNullable<Awaited<ReturnType<typeof updateCoupon>>>
export type UpdateCouponMutationBody = AffiliateUpdateCouponSchema
export type UpdateCouponMutationError = unknown

/**
 * @summary Update Coupon
 */
export const useUpdateCoupon = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCoupon>>,
      TError,
      { partnerId: string; couponId: string; data: AffiliateUpdateCouponSchema },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCoupon>>,
  TError,
  { partnerId: string; couponId: string; data: AffiliateUpdateCouponSchema },
  TContext
> => {
  const mutationOptions = getUpdateCouponMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Delete Coupon
 */
export const deleteCoupon = (partnerId: string, couponId: string) => {
  return deleteCouponMutator<DeleteCoupon200>({
    url: `/v4/affiliates/admin/partners/${partnerId}/coupons/${couponId}/`,
    method: 'DELETE',
  })
}

export const getDeleteCouponMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCoupon>>,
    TError,
    { partnerId: string; couponId: string },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCoupon>>,
  TError,
  { partnerId: string; couponId: string },
  TContext
> => {
  const mutationKey = ['deleteCoupon']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCoupon>>,
    { partnerId: string; couponId: string }
  > = (props) => {
    const { partnerId, couponId } = props ?? {}

    return deleteCoupon(partnerId, couponId)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteCouponMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCoupon>>>

export type DeleteCouponMutationError = unknown

/**
 * @summary Delete Coupon
 */
export const useDeleteCoupon = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCoupon>>,
      TError,
      { partnerId: string; couponId: string },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCoupon>>,
  TError,
  { partnerId: string; couponId: string },
  TContext
> => {
  const mutationOptions = getDeleteCouponMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary List All Coupons
 */
export const listAllCoupons = (params?: ListAllCouponsParams, signal?: AbortSignal) => {
  return listAllCouponsMutator<AffiliateAdminCouponListSchema[]>({
    url: `/v4/affiliates/admin/coupons/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getListAllCouponsQueryKey = (params?: ListAllCouponsParams) => {
  return [`/v4/affiliates/admin/coupons/`, ...(params ? [params] : [])] as const
}

export const getListAllCouponsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAllCoupons>>,
  TError = unknown,
>(
  params?: ListAllCouponsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllCoupons>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListAllCouponsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllCoupons>>> = ({ signal }) =>
    listAllCoupons(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAllCoupons>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAllCouponsQueryResult = NonNullable<Awaited<ReturnType<typeof listAllCoupons>>>
export type ListAllCouponsQueryError = unknown

export function useListAllCoupons<
  TData = Awaited<ReturnType<typeof listAllCoupons>>,
  TError = unknown,
>(
  params: undefined | ListAllCouponsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllCoupons>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllCoupons>>,
          TError,
          Awaited<ReturnType<typeof listAllCoupons>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllCoupons<
  TData = Awaited<ReturnType<typeof listAllCoupons>>,
  TError = unknown,
>(
  params?: ListAllCouponsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllCoupons>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllCoupons>>,
          TError,
          Awaited<ReturnType<typeof listAllCoupons>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllCoupons<
  TData = Awaited<ReturnType<typeof listAllCoupons>>,
  TError = unknown,
>(
  params?: ListAllCouponsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllCoupons>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List All Coupons
 */

export function useListAllCoupons<
  TData = Awaited<ReturnType<typeof listAllCoupons>>,
  TError = unknown,
>(
  params?: ListAllCouponsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllCoupons>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAllCouponsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getListAllCouponsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listAllCoupons>>,
  TError = unknown,
>(
  params?: ListAllCouponsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAllCoupons>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListAllCouponsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllCoupons>>> = ({ signal }) =>
    listAllCoupons(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listAllCoupons>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAllCouponsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAllCoupons>>
>
export type ListAllCouponsSuspenseQueryError = unknown

export function useListAllCouponsSuspense<
  TData = Awaited<ReturnType<typeof listAllCoupons>>,
  TError = unknown,
>(
  params: undefined | ListAllCouponsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAllCoupons>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllCouponsSuspense<
  TData = Awaited<ReturnType<typeof listAllCoupons>>,
  TError = unknown,
>(
  params?: ListAllCouponsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAllCoupons>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllCouponsSuspense<
  TData = Awaited<ReturnType<typeof listAllCoupons>>,
  TError = unknown,
>(
  params?: ListAllCouponsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAllCoupons>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List All Coupons
 */

export function useListAllCouponsSuspense<
  TData = Awaited<ReturnType<typeof listAllCoupons>>,
  TError = unknown,
>(
  params?: ListAllCouponsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAllCoupons>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAllCouponsSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary List Partner Commissions
 */
export const listPartnerCommissions = (
  partnerId: string,
  params?: ListPartnerCommissionsParams,
  signal?: AbortSignal,
) => {
  return listPartnerCommissionsMutator<AffiliateAdminCommissionSchema[]>({
    url: `/v4/affiliates/admin/partners/${partnerId}/commissions/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getListPartnerCommissionsQueryKey = (
  partnerId?: string,
  params?: ListPartnerCommissionsParams,
) => {
  return [
    `/v4/affiliates/admin/partners/${partnerId}/commissions/`,
    ...(params ? [params] : []),
  ] as const
}

export const getListPartnerCommissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPartnerCommissions>>,
  TError = unknown,
>(
  partnerId: string,
  params?: ListPartnerCommissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listPartnerCommissions>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListPartnerCommissionsQueryKey(partnerId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPartnerCommissions>>> = ({ signal }) =>
    listPartnerCommissions(partnerId, params, signal)

  return { queryKey, queryFn, enabled: !!partnerId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPartnerCommissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPartnerCommissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPartnerCommissions>>
>
export type ListPartnerCommissionsQueryError = unknown

export function useListPartnerCommissions<
  TData = Awaited<ReturnType<typeof listPartnerCommissions>>,
  TError = unknown,
>(
  partnerId: string,
  params: undefined | ListPartnerCommissionsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listPartnerCommissions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPartnerCommissions>>,
          TError,
          Awaited<ReturnType<typeof listPartnerCommissions>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPartnerCommissions<
  TData = Awaited<ReturnType<typeof listPartnerCommissions>>,
  TError = unknown,
>(
  partnerId: string,
  params?: ListPartnerCommissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listPartnerCommissions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPartnerCommissions>>,
          TError,
          Awaited<ReturnType<typeof listPartnerCommissions>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPartnerCommissions<
  TData = Awaited<ReturnType<typeof listPartnerCommissions>>,
  TError = unknown,
>(
  partnerId: string,
  params?: ListPartnerCommissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listPartnerCommissions>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Partner Commissions
 */

export function useListPartnerCommissions<
  TData = Awaited<ReturnType<typeof listPartnerCommissions>>,
  TError = unknown,
>(
  partnerId: string,
  params?: ListPartnerCommissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listPartnerCommissions>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListPartnerCommissionsQueryOptions(partnerId, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getListPartnerCommissionsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listPartnerCommissions>>,
  TError = unknown,
>(
  partnerId: string,
  params?: ListPartnerCommissionsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPartnerCommissions>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListPartnerCommissionsQueryKey(partnerId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPartnerCommissions>>> = ({ signal }) =>
    listPartnerCommissions(partnerId, params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listPartnerCommissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPartnerCommissionsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPartnerCommissions>>
>
export type ListPartnerCommissionsSuspenseQueryError = unknown

export function useListPartnerCommissionsSuspense<
  TData = Awaited<ReturnType<typeof listPartnerCommissions>>,
  TError = unknown,
>(
  partnerId: string,
  params: undefined | ListPartnerCommissionsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPartnerCommissions>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPartnerCommissionsSuspense<
  TData = Awaited<ReturnType<typeof listPartnerCommissions>>,
  TError = unknown,
>(
  partnerId: string,
  params?: ListPartnerCommissionsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPartnerCommissions>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPartnerCommissionsSuspense<
  TData = Awaited<ReturnType<typeof listPartnerCommissions>>,
  TError = unknown,
>(
  partnerId: string,
  params?: ListPartnerCommissionsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPartnerCommissions>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Partner Commissions
 */

export function useListPartnerCommissionsSuspense<
  TData = Awaited<ReturnType<typeof listPartnerCommissions>>,
  TError = unknown,
>(
  partnerId: string,
  params?: ListPartnerCommissionsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPartnerCommissions>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListPartnerCommissionsSuspenseQueryOptions(partnerId, params, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Record a signed manual balance correction (UNLOCKED MANUAL commission) for a partner.

Used during the legacy migration to reconcile a partner's available_balance to the old
system's owed figure. Positive credits, negative debits; returns the created row and the
partner's available_balance after applying it.
 * @summary Create Partner Commission Correction
 */
export const createPartnerCommissionCorrection = (
  partnerId: string,
  affiliateAdminCommissionCorrectionSchema: AffiliateAdminCommissionCorrectionSchema,
  signal?: AbortSignal,
) => {
  return createPartnerCommissionCorrectionMutator<AffiliateAdminCommissionCorrectionResponseSchema>(
    {
      url: `/v4/affiliates/admin/partners/${partnerId}/commissions/correction/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: affiliateAdminCommissionCorrectionSchema,
      signal,
    },
  )
}

export const getCreatePartnerCommissionCorrectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPartnerCommissionCorrection>>,
    TError,
    { partnerId: string; data: AffiliateAdminCommissionCorrectionSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPartnerCommissionCorrection>>,
  TError,
  { partnerId: string; data: AffiliateAdminCommissionCorrectionSchema },
  TContext
> => {
  const mutationKey = ['createPartnerCommissionCorrection']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPartnerCommissionCorrection>>,
    { partnerId: string; data: AffiliateAdminCommissionCorrectionSchema }
  > = (props) => {
    const { partnerId, data } = props ?? {}

    return createPartnerCommissionCorrection(partnerId, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreatePartnerCommissionCorrectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPartnerCommissionCorrection>>
>
export type CreatePartnerCommissionCorrectionMutationBody = AffiliateAdminCommissionCorrectionSchema
export type CreatePartnerCommissionCorrectionMutationError = unknown

/**
 * @summary Create Partner Commission Correction
 */
export const useCreatePartnerCommissionCorrection = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPartnerCommissionCorrection>>,
      TError,
      { partnerId: string; data: AffiliateAdminCommissionCorrectionSchema },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createPartnerCommissionCorrection>>,
  TError,
  { partnerId: string; data: AffiliateAdminCommissionCorrectionSchema },
  TContext
> => {
  const mutationOptions = getCreatePartnerCommissionCorrectionMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary List Orders
 */
export const listOrders = (params?: ListOrdersParams, signal?: AbortSignal) => {
  return listOrdersMutator<AffiliateAdminOrderListResponseSchema>({
    url: `/v4/affiliates/admin/orders/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getListOrdersQueryKey = (params?: ListOrdersParams) => {
  return [`/v4/affiliates/admin/orders/`, ...(params ? [params] : [])] as const
}

export const getListOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof listOrders>>,
  TError = unknown,
>(
  params?: ListOrdersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrders>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListOrdersQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrders>>> = ({ signal }) =>
    listOrders(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOrders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof listOrders>>>
export type ListOrdersQueryError = unknown

export function useListOrders<TData = Awaited<ReturnType<typeof listOrders>>, TError = unknown>(
  params: undefined | ListOrdersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrders>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrders>>,
          TError,
          Awaited<ReturnType<typeof listOrders>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrders<TData = Awaited<ReturnType<typeof listOrders>>, TError = unknown>(
  params?: ListOrdersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrders>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrders>>,
          TError,
          Awaited<ReturnType<typeof listOrders>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrders<TData = Awaited<ReturnType<typeof listOrders>>, TError = unknown>(
  params?: ListOrdersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrders>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Orders
 */

export function useListOrders<TData = Awaited<ReturnType<typeof listOrders>>, TError = unknown>(
  params?: ListOrdersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrders>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListOrdersQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getListOrdersSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listOrders>>,
  TError = unknown,
>(
  params?: ListOrdersParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrders>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListOrdersQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrders>>> = ({ signal }) =>
    listOrders(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listOrders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrdersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listOrders>>>
export type ListOrdersSuspenseQueryError = unknown

export function useListOrdersSuspense<
  TData = Awaited<ReturnType<typeof listOrders>>,
  TError = unknown,
>(
  params: undefined | ListOrdersParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrders>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrdersSuspense<
  TData = Awaited<ReturnType<typeof listOrders>>,
  TError = unknown,
>(
  params?: ListOrdersParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrders>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrdersSuspense<
  TData = Awaited<ReturnType<typeof listOrders>>,
  TError = unknown,
>(
  params?: ListOrdersParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrders>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Orders
 */

export function useListOrdersSuspense<
  TData = Awaited<ReturnType<typeof listOrders>>,
  TError = unknown,
>(
  params?: ListOrdersParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listOrders>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListOrdersSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary List Tiers
 */
export const listTiers = (signal?: AbortSignal) => {
  return listTiersMutator<AdminAffiliateTierSchema[]>({
    url: `/v4/affiliates/admin/tiers/`,
    method: 'GET',
    signal,
  })
}

export const getListTiersQueryKey = () => {
  return [`/v4/affiliates/admin/tiers/`] as const
}

export const getListTiersQueryOptions = <
  TData = Awaited<ReturnType<typeof listTiers>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTiers>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListTiersQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTiers>>> = ({ signal }) =>
    listTiers(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTiers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTiersQueryResult = NonNullable<Awaited<ReturnType<typeof listTiers>>>
export type ListTiersQueryError = unknown

export function useListTiers<TData = Awaited<ReturnType<typeof listTiers>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTiers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTiers>>,
          TError,
          Awaited<ReturnType<typeof listTiers>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTiers<TData = Awaited<ReturnType<typeof listTiers>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTiers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTiers>>,
          TError,
          Awaited<ReturnType<typeof listTiers>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTiers<TData = Awaited<ReturnType<typeof listTiers>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTiers>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Tiers
 */

export function useListTiers<TData = Awaited<ReturnType<typeof listTiers>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTiers>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListTiersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getListTiersSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listTiers>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTiers>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListTiersQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTiers>>> = ({ signal }) =>
    listTiers(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listTiers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTiersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listTiers>>>
export type ListTiersSuspenseQueryError = unknown

export function useListTiersSuspense<
  TData = Awaited<ReturnType<typeof listTiers>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTiers>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTiersSuspense<
  TData = Awaited<ReturnType<typeof listTiers>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTiers>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTiersSuspense<
  TData = Awaited<ReturnType<typeof listTiers>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTiers>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Tiers
 */

export function useListTiersSuspense<
  TData = Awaited<ReturnType<typeof listTiers>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listTiers>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListTiersSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Create Tier
 */
export const createTier = (
  affiliateCreateTierSchema: AffiliateCreateTierSchema,
  signal?: AbortSignal,
) => {
  return createTierMutator<AdminAffiliateTierSchema>({
    url: `/v4/affiliates/admin/tiers/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: affiliateCreateTierSchema,
    signal,
  })
}

export const getCreateTierMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTier>>,
    TError,
    { data: AffiliateCreateTierSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTier>>,
  TError,
  { data: AffiliateCreateTierSchema },
  TContext
> => {
  const mutationKey = ['createTier']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTier>>,
    { data: AffiliateCreateTierSchema }
  > = (props) => {
    const { data } = props ?? {}

    return createTier(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateTierMutationResult = NonNullable<Awaited<ReturnType<typeof createTier>>>
export type CreateTierMutationBody = AffiliateCreateTierSchema
export type CreateTierMutationError = unknown

/**
 * @summary Create Tier
 */
export const useCreateTier = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTier>>,
      TError,
      { data: AffiliateCreateTierSchema },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createTier>>,
  TError,
  { data: AffiliateCreateTierSchema },
  TContext
> => {
  const mutationOptions = getCreateTierMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Update Tier
 */
export const updateTier = (
  tierId: number,
  affiliateUpdateTierSchema: AffiliateUpdateTierSchema,
) => {
  return updateTierMutator<AdminAffiliateTierSchema>({
    url: `/v4/affiliates/admin/tiers/${tierId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: affiliateUpdateTierSchema,
  })
}

export const getUpdateTierMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTier>>,
    TError,
    { tierId: number; data: AffiliateUpdateTierSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTier>>,
  TError,
  { tierId: number; data: AffiliateUpdateTierSchema },
  TContext
> => {
  const mutationKey = ['updateTier']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTier>>,
    { tierId: number; data: AffiliateUpdateTierSchema }
  > = (props) => {
    const { tierId, data } = props ?? {}

    return updateTier(tierId, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateTierMutationResult = NonNullable<Awaited<ReturnType<typeof updateTier>>>
export type UpdateTierMutationBody = AffiliateUpdateTierSchema
export type UpdateTierMutationError = unknown

/**
 * @summary Update Tier
 */
export const useUpdateTier = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTier>>,
      TError,
      { tierId: number; data: AffiliateUpdateTierSchema },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateTier>>,
  TError,
  { tierId: number; data: AffiliateUpdateTierSchema },
  TContext
> => {
  const mutationOptions = getUpdateTierMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Delete Tier
 */
export const deleteTier = (tierId: number) => {
  return deleteTierMutator<DeleteTier200>({
    url: `/v4/affiliates/admin/tiers/${tierId}/`,
    method: 'DELETE',
  })
}

export const getDeleteTierMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTier>>,
    TError,
    { tierId: number },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTier>>,
  TError,
  { tierId: number },
  TContext
> => {
  const mutationKey = ['deleteTier']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTier>>, { tierId: number }> = (
    props,
  ) => {
    const { tierId } = props ?? {}

    return deleteTier(tierId)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteTierMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTier>>>

export type DeleteTierMutationError = unknown

/**
 * @summary Delete Tier
 */
export const useDeleteTier = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTier>>,
      TError,
      { tierId: number },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTier>>,
  TError,
  { tierId: number },
  TContext
> => {
  const mutationOptions = getDeleteTierMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary List Payouts
 */
export const listPayouts = (params?: ListPayoutsParams, signal?: AbortSignal) => {
  return listPayoutsMutator<AffiliateAdminPayoutSchema[]>({
    url: `/v4/affiliates/admin/payouts/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getListPayoutsQueryKey = (params?: ListPayoutsParams) => {
  return [`/v4/affiliates/admin/payouts/`, ...(params ? [params] : [])] as const
}

export const getListPayoutsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPayouts>>,
  TError = unknown,
>(
  params?: ListPayoutsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayouts>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListPayoutsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPayouts>>> = ({ signal }) =>
    listPayouts(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPayouts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPayoutsQueryResult = NonNullable<Awaited<ReturnType<typeof listPayouts>>>
export type ListPayoutsQueryError = unknown

export function useListPayouts<TData = Awaited<ReturnType<typeof listPayouts>>, TError = unknown>(
  params: undefined | ListPayoutsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayouts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPayouts>>,
          TError,
          Awaited<ReturnType<typeof listPayouts>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayouts<TData = Awaited<ReturnType<typeof listPayouts>>, TError = unknown>(
  params?: ListPayoutsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayouts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPayouts>>,
          TError,
          Awaited<ReturnType<typeof listPayouts>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayouts<TData = Awaited<ReturnType<typeof listPayouts>>, TError = unknown>(
  params?: ListPayoutsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayouts>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Payouts
 */

export function useListPayouts<TData = Awaited<ReturnType<typeof listPayouts>>, TError = unknown>(
  params?: ListPayoutsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayouts>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListPayoutsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getListPayoutsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listPayouts>>,
  TError = unknown,
>(
  params?: ListPayoutsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPayouts>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListPayoutsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPayouts>>> = ({ signal }) =>
    listPayouts(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listPayouts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPayoutsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listPayouts>>>
export type ListPayoutsSuspenseQueryError = unknown

export function useListPayoutsSuspense<
  TData = Awaited<ReturnType<typeof listPayouts>>,
  TError = unknown,
>(
  params: undefined | ListPayoutsParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPayouts>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayoutsSuspense<
  TData = Awaited<ReturnType<typeof listPayouts>>,
  TError = unknown,
>(
  params?: ListPayoutsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPayouts>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayoutsSuspense<
  TData = Awaited<ReturnType<typeof listPayouts>>,
  TError = unknown,
>(
  params?: ListPayoutsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPayouts>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Payouts
 */

export function useListPayoutsSuspense<
  TData = Awaited<ReturnType<typeof listPayouts>>,
  TError = unknown,
>(
  params?: ListPayoutsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPayouts>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListPayoutsSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Update Payout Status
 */
export const updatePayoutStatus = (
  payoutId: string,
  affiliatePayoutStatusUpdateSchema: AffiliatePayoutStatusUpdateSchema,
) => {
  return updatePayoutStatusMutator<AffiliateAdminPayoutSchema>({
    url: `/v4/affiliates/admin/payouts/${payoutId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: affiliatePayoutStatusUpdateSchema,
  })
}

export const getUpdatePayoutStatusMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePayoutStatus>>,
    TError,
    { payoutId: string; data: AffiliatePayoutStatusUpdateSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePayoutStatus>>,
  TError,
  { payoutId: string; data: AffiliatePayoutStatusUpdateSchema },
  TContext
> => {
  const mutationKey = ['updatePayoutStatus']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePayoutStatus>>,
    { payoutId: string; data: AffiliatePayoutStatusUpdateSchema }
  > = (props) => {
    const { payoutId, data } = props ?? {}

    return updatePayoutStatus(payoutId, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdatePayoutStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePayoutStatus>>
>
export type UpdatePayoutStatusMutationBody = AffiliatePayoutStatusUpdateSchema
export type UpdatePayoutStatusMutationError = ErrorResponse

/**
 * @summary Update Payout Status
 */
export const useUpdatePayoutStatus = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePayoutStatus>>,
      TError,
      { payoutId: string; data: AffiliatePayoutStatusUpdateSchema },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePayoutStatus>>,
  TError,
  { payoutId: string; data: AffiliatePayoutStatusUpdateSchema },
  TContext
> => {
  const mutationOptions = getUpdatePayoutStatusMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Adjust Payout Amount
 */
export const adjustPayoutAmount = (
  payoutId: string,
  affiliatePayoutAdjustAmountSchema: AffiliatePayoutAdjustAmountSchema,
) => {
  return adjustPayoutAmountMutator<AffiliateAdminPayoutSchema>({
    url: `/v4/affiliates/admin/payouts/${payoutId}/adjust/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: affiliatePayoutAdjustAmountSchema,
  })
}

export const getAdjustPayoutAmountMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adjustPayoutAmount>>,
    TError,
    { payoutId: string; data: AffiliatePayoutAdjustAmountSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof adjustPayoutAmount>>,
  TError,
  { payoutId: string; data: AffiliatePayoutAdjustAmountSchema },
  TContext
> => {
  const mutationKey = ['adjustPayoutAmount']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adjustPayoutAmount>>,
    { payoutId: string; data: AffiliatePayoutAdjustAmountSchema }
  > = (props) => {
    const { payoutId, data } = props ?? {}

    return adjustPayoutAmount(payoutId, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdjustPayoutAmountMutationResult = NonNullable<
  Awaited<ReturnType<typeof adjustPayoutAmount>>
>
export type AdjustPayoutAmountMutationBody = AffiliatePayoutAdjustAmountSchema
export type AdjustPayoutAmountMutationError = unknown

/**
 * @summary Adjust Payout Amount
 */
export const useAdjustPayoutAmount = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adjustPayoutAmount>>,
      TError,
      { payoutId: string; data: AffiliatePayoutAdjustAmountSchema },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adjustPayoutAmount>>,
  TError,
  { payoutId: string; data: AffiliatePayoutAdjustAmountSchema },
  TContext
> => {
  const mutationOptions = getAdjustPayoutAmountMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Get Admin Ledger
 */
export const getAdminLedger = (params?: GetAdminLedgerParams, signal?: AbortSignal) => {
  return getAdminLedgerMutator<AffiliateAdminLedgerResponseSchema>({
    url: `/v4/affiliates/admin/ledger/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getGetAdminLedgerQueryKey = (params?: GetAdminLedgerParams) => {
  return [`/v4/affiliates/admin/ledger/`, ...(params ? [params] : [])] as const
}

export const getGetAdminLedgerQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminLedger>>,
  TError = unknown,
>(
  params?: GetAdminLedgerParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLedger>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAdminLedgerQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminLedger>>> = ({ signal }) =>
    getAdminLedger(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminLedger>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminLedgerQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminLedger>>>
export type GetAdminLedgerQueryError = unknown

export function useGetAdminLedger<
  TData = Awaited<ReturnType<typeof getAdminLedger>>,
  TError = unknown,
>(
  params: undefined | GetAdminLedgerParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLedger>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminLedger>>,
          TError,
          Awaited<ReturnType<typeof getAdminLedger>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminLedger<
  TData = Awaited<ReturnType<typeof getAdminLedger>>,
  TError = unknown,
>(
  params?: GetAdminLedgerParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLedger>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminLedger>>,
          TError,
          Awaited<ReturnType<typeof getAdminLedger>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminLedger<
  TData = Awaited<ReturnType<typeof getAdminLedger>>,
  TError = unknown,
>(
  params?: GetAdminLedgerParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLedger>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Admin Ledger
 */

export function useGetAdminLedger<
  TData = Awaited<ReturnType<typeof getAdminLedger>>,
  TError = unknown,
>(
  params?: GetAdminLedgerParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLedger>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAdminLedgerQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getGetAdminLedgerSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminLedger>>,
  TError = unknown,
>(
  params?: GetAdminLedgerParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminLedger>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAdminLedgerQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminLedger>>> = ({ signal }) =>
    getAdminLedger(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getAdminLedger>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminLedgerSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminLedger>>
>
export type GetAdminLedgerSuspenseQueryError = unknown

export function useGetAdminLedgerSuspense<
  TData = Awaited<ReturnType<typeof getAdminLedger>>,
  TError = unknown,
>(
  params: undefined | GetAdminLedgerParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminLedger>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminLedgerSuspense<
  TData = Awaited<ReturnType<typeof getAdminLedger>>,
  TError = unknown,
>(
  params?: GetAdminLedgerParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminLedger>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminLedgerSuspense<
  TData = Awaited<ReturnType<typeof getAdminLedger>>,
  TError = unknown,
>(
  params?: GetAdminLedgerParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminLedger>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Admin Ledger
 */

export function useGetAdminLedgerSuspense<
  TData = Awaited<ReturnType<typeof getAdminLedger>>,
  TError = unknown,
>(
  params?: GetAdminLedgerParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminLedger>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAdminLedgerSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary List Admin Access
 */
export const listAdminAccess = (signal?: AbortSignal) => {
  return listAdminAccessMutator<AffiliateAdminAccessSchema[]>({
    url: `/v4/affiliates/admin/access/`,
    method: 'GET',
    signal,
  })
}

export const getListAdminAccessQueryKey = () => {
  return [`/v4/affiliates/admin/access/`] as const
}

export const getListAdminAccessQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminAccess>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAccess>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListAdminAccessQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminAccess>>> = ({ signal }) =>
    listAdminAccess(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminAccess>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminAccessQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminAccess>>>
export type ListAdminAccessQueryError = ErrorResponse

export function useListAdminAccess<
  TData = Awaited<ReturnType<typeof listAdminAccess>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAccess>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminAccess>>,
          TError,
          Awaited<ReturnType<typeof listAdminAccess>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminAccess<
  TData = Awaited<ReturnType<typeof listAdminAccess>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAccess>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminAccess>>,
          TError,
          Awaited<ReturnType<typeof listAdminAccess>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminAccess<
  TData = Awaited<ReturnType<typeof listAdminAccess>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAccess>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Admin Access
 */

export function useListAdminAccess<
  TData = Awaited<ReturnType<typeof listAdminAccess>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAccess>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAdminAccessQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getListAdminAccessSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminAccess>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAdminAccess>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListAdminAccessQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminAccess>>> = ({ signal }) =>
    listAdminAccess(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listAdminAccess>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminAccessSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminAccess>>
>
export type ListAdminAccessSuspenseQueryError = ErrorResponse

export function useListAdminAccessSuspense<
  TData = Awaited<ReturnType<typeof listAdminAccess>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAdminAccess>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminAccessSuspense<
  TData = Awaited<ReturnType<typeof listAdminAccess>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAdminAccess>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminAccessSuspense<
  TData = Awaited<ReturnType<typeof listAdminAccess>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAdminAccess>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Admin Access
 */

export function useListAdminAccessSuspense<
  TData = Awaited<ReturnType<typeof listAdminAccess>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAdminAccess>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAdminAccessSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * The history of admin-access grants and revokes, newest first.
 * @summary List Admin Access Changes
 */
export const listAdminAccessChanges = (
  params?: ListAdminAccessChangesParams,
  signal?: AbortSignal,
) => {
  return listAdminAccessChangesMutator<AffiliateAdminAccessChangeListResponseSchema>({
    url: `/v4/affiliates/admin/access/changes/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getListAdminAccessChangesQueryKey = (params?: ListAdminAccessChangesParams) => {
  return [`/v4/affiliates/admin/access/changes/`, ...(params ? [params] : [])] as const
}

export const getListAdminAccessChangesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminAccessChanges>>,
  TError = ErrorResponse,
>(
  params?: ListAdminAccessChangesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAdminAccessChanges>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListAdminAccessChangesQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminAccessChanges>>> = ({ signal }) =>
    listAdminAccessChanges(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminAccessChanges>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminAccessChangesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminAccessChanges>>
>
export type ListAdminAccessChangesQueryError = ErrorResponse

export function useListAdminAccessChanges<
  TData = Awaited<ReturnType<typeof listAdminAccessChanges>>,
  TError = ErrorResponse,
>(
  params: undefined | ListAdminAccessChangesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAdminAccessChanges>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminAccessChanges>>,
          TError,
          Awaited<ReturnType<typeof listAdminAccessChanges>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminAccessChanges<
  TData = Awaited<ReturnType<typeof listAdminAccessChanges>>,
  TError = ErrorResponse,
>(
  params?: ListAdminAccessChangesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAdminAccessChanges>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminAccessChanges>>,
          TError,
          Awaited<ReturnType<typeof listAdminAccessChanges>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminAccessChanges<
  TData = Awaited<ReturnType<typeof listAdminAccessChanges>>,
  TError = ErrorResponse,
>(
  params?: ListAdminAccessChangesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAdminAccessChanges>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Admin Access Changes
 */

export function useListAdminAccessChanges<
  TData = Awaited<ReturnType<typeof listAdminAccessChanges>>,
  TError = ErrorResponse,
>(
  params?: ListAdminAccessChangesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAdminAccessChanges>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAdminAccessChangesQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getListAdminAccessChangesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminAccessChanges>>,
  TError = ErrorResponse,
>(
  params?: ListAdminAccessChangesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAdminAccessChanges>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListAdminAccessChangesQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminAccessChanges>>> = ({ signal }) =>
    listAdminAccessChanges(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listAdminAccessChanges>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminAccessChangesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminAccessChanges>>
>
export type ListAdminAccessChangesSuspenseQueryError = ErrorResponse

export function useListAdminAccessChangesSuspense<
  TData = Awaited<ReturnType<typeof listAdminAccessChanges>>,
  TError = ErrorResponse,
>(
  params: undefined | ListAdminAccessChangesParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAdminAccessChanges>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminAccessChangesSuspense<
  TData = Awaited<ReturnType<typeof listAdminAccessChanges>>,
  TError = ErrorResponse,
>(
  params?: ListAdminAccessChangesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAdminAccessChanges>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminAccessChangesSuspense<
  TData = Awaited<ReturnType<typeof listAdminAccessChanges>>,
  TError = ErrorResponse,
>(
  params?: ListAdminAccessChangesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAdminAccessChanges>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Admin Access Changes
 */

export function useListAdminAccessChangesSuspense<
  TData = Awaited<ReturnType<typeof listAdminAccessChanges>>,
  TError = ErrorResponse,
>(
  params?: ListAdminAccessChangesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAdminAccessChanges>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAdminAccessChangesSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Give the GTO Wizard account that uses this email the ADMIN role. An account with no affiliate partner gets a non-earning staff partner record. Refused for your own account, for an email that no account uses, and for a person who already has admin access.
 * @summary Grant Admin Access View
 */
export const grantAdminAccessView = (
  affiliateAdminAccessGrantSchema: AffiliateAdminAccessGrantSchema,
  signal?: AbortSignal,
) => {
  return grantAdminAccessViewMutator<AffiliateAdminAccessSchema>({
    url: `/v4/affiliates/admin/access/grant/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: affiliateAdminAccessGrantSchema,
    signal,
  })
}

export const getGrantAdminAccessViewMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantAdminAccessView>>,
    TError,
    { data: AffiliateAdminAccessGrantSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof grantAdminAccessView>>,
  TError,
  { data: AffiliateAdminAccessGrantSchema },
  TContext
> => {
  const mutationKey = ['grantAdminAccessView']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof grantAdminAccessView>>,
    { data: AffiliateAdminAccessGrantSchema }
  > = (props) => {
    const { data } = props ?? {}

    return grantAdminAccessView(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type GrantAdminAccessViewMutationResult = NonNullable<
  Awaited<ReturnType<typeof grantAdminAccessView>>
>
export type GrantAdminAccessViewMutationBody = AffiliateAdminAccessGrantSchema
export type GrantAdminAccessViewMutationError = ErrorResponse

/**
 * @summary Grant Admin Access View
 */
export const useGrantAdminAccessView = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof grantAdminAccessView>>,
      TError,
      { data: AffiliateAdminAccessGrantSchema },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof grantAdminAccessView>>,
  TError,
  { data: AffiliateAdminAccessGrantSchema },
  TContext
> => {
  const mutationOptions = getGrantAdminAccessViewMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * Return a MANAGER or ADMIN partner to the PARTNER role. Refused for your own partner and for a partner that has no admin access.
 * @summary Revoke Admin Access View
 */
export const revokeAdminAccessView = (partnerId: string, signal?: AbortSignal) => {
  return revokeAdminAccessViewMutator<AffiliateAdminAccessSchema>({
    url: `/v4/affiliates/admin/access/${partnerId}/revoke/`,
    method: 'POST',
    signal,
  })
}

export const getRevokeAdminAccessViewMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeAdminAccessView>>,
    TError,
    { partnerId: string },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeAdminAccessView>>,
  TError,
  { partnerId: string },
  TContext
> => {
  const mutationKey = ['revokeAdminAccessView']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeAdminAccessView>>,
    { partnerId: string }
  > = (props) => {
    const { partnerId } = props ?? {}

    return revokeAdminAccessView(partnerId)
  }

  return { mutationFn, ...mutationOptions }
}

export type RevokeAdminAccessViewMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeAdminAccessView>>
>

export type RevokeAdminAccessViewMutationError = ErrorResponse

/**
 * @summary Revoke Admin Access View
 */
export const useRevokeAdminAccessView = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof revokeAdminAccessView>>,
      TError,
      { partnerId: string },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof revokeAdminAccessView>>,
  TError,
  { partnerId: string },
  TContext
> => {
  const mutationOptions = getRevokeAdminAccessViewMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary List Assets
 */
export const listAssets = (params?: ListAssetsParams, signal?: AbortSignal) => {
  return listAssetsMutator<AffiliateAssetSchema[]>({
    url: `/v4/affiliates/admin/assets/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getListAssetsQueryKey = (params?: ListAssetsParams) => {
  return [`/v4/affiliates/admin/assets/`, ...(params ? [params] : [])] as const
}

export const getListAssetsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAssets>>,
  TError = unknown,
>(
  params?: ListAssetsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListAssetsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssets>>> = ({ signal }) =>
    listAssets(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAssets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof listAssets>>>
export type ListAssetsQueryError = unknown

export function useListAssets<TData = Awaited<ReturnType<typeof listAssets>>, TError = unknown>(
  params: undefined | ListAssetsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssets>>,
          TError,
          Awaited<ReturnType<typeof listAssets>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssets<TData = Awaited<ReturnType<typeof listAssets>>, TError = unknown>(
  params?: ListAssetsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssets>>,
          TError,
          Awaited<ReturnType<typeof listAssets>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssets<TData = Awaited<ReturnType<typeof listAssets>>, TError = unknown>(
  params?: ListAssetsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Assets
 */

export function useListAssets<TData = Awaited<ReturnType<typeof listAssets>>, TError = unknown>(
  params?: ListAssetsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAssetsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getListAssetsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listAssets>>,
  TError = unknown,
>(
  params?: ListAssetsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListAssetsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssets>>> = ({ signal }) =>
    listAssets(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listAssets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAssetsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listAssets>>>
export type ListAssetsSuspenseQueryError = unknown

export function useListAssetsSuspense<
  TData = Awaited<ReturnType<typeof listAssets>>,
  TError = unknown,
>(
  params: undefined | ListAssetsParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssetsSuspense<
  TData = Awaited<ReturnType<typeof listAssets>>,
  TError = unknown,
>(
  params?: ListAssetsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssetsSuspense<
  TData = Awaited<ReturnType<typeof listAssets>>,
  TError = unknown,
>(
  params?: ListAssetsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Assets
 */

export function useListAssetsSuspense<
  TData = Awaited<ReturnType<typeof listAssets>>,
  TError = unknown,
>(
  params?: ListAssetsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAssetsSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Upload Asset
 */
export const uploadAsset = (
  affiliateAssetUploadRequestSchema: AffiliateAssetUploadRequestSchema,
  signal?: AbortSignal,
) => {
  return uploadAssetMutator<AffiliateAssetUploadResponseSchema>({
    url: `/v4/affiliates/admin/assets/upload/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: affiliateAssetUploadRequestSchema,
    signal,
  })
}

export const getUploadAssetMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadAsset>>,
    TError,
    { data: AffiliateAssetUploadRequestSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadAsset>>,
  TError,
  { data: AffiliateAssetUploadRequestSchema },
  TContext
> => {
  const mutationKey = ['uploadAsset']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadAsset>>,
    { data: AffiliateAssetUploadRequestSchema }
  > = (props) => {
    const { data } = props ?? {}

    return uploadAsset(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type UploadAssetMutationResult = NonNullable<Awaited<ReturnType<typeof uploadAsset>>>
export type UploadAssetMutationBody = AffiliateAssetUploadRequestSchema
export type UploadAssetMutationError = unknown

/**
 * @summary Upload Asset
 */
export const useUploadAsset = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadAsset>>,
      TError,
      { data: AffiliateAssetUploadRequestSchema },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadAsset>>,
  TError,
  { data: AffiliateAssetUploadRequestSchema },
  TContext
> => {
  const mutationOptions = getUploadAssetMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Rename Asset
 */
export const renameAsset = (
  assetId: string,
  affiliateAssetRenameSchema: AffiliateAssetRenameSchema,
) => {
  return renameAssetMutator<AffiliateAssetSchema>({
    url: `/v4/affiliates/admin/assets/${assetId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: affiliateAssetRenameSchema,
  })
}

export const getRenameAssetMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renameAsset>>,
    TError,
    { assetId: string; data: AffiliateAssetRenameSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof renameAsset>>,
  TError,
  { assetId: string; data: AffiliateAssetRenameSchema },
  TContext
> => {
  const mutationKey = ['renameAsset']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof renameAsset>>,
    { assetId: string; data: AffiliateAssetRenameSchema }
  > = (props) => {
    const { assetId, data } = props ?? {}

    return renameAsset(assetId, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type RenameAssetMutationResult = NonNullable<Awaited<ReturnType<typeof renameAsset>>>
export type RenameAssetMutationBody = AffiliateAssetRenameSchema
export type RenameAssetMutationError = unknown

/**
 * @summary Rename Asset
 */
export const useRenameAsset = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof renameAsset>>,
      TError,
      { assetId: string; data: AffiliateAssetRenameSchema },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof renameAsset>>,
  TError,
  { assetId: string; data: AffiliateAssetRenameSchema },
  TContext
> => {
  const mutationOptions = getRenameAssetMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Delete Asset
 */
export const deleteAsset = (assetId: string) => {
  return deleteAssetMutator<DeleteAsset200>({
    url: `/v4/affiliates/admin/assets/${assetId}/`,
    method: 'DELETE',
  })
}

export const getDeleteAssetMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAsset>>,
    TError,
    { assetId: string },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAsset>>,
  TError,
  { assetId: string },
  TContext
> => {
  const mutationKey = ['deleteAsset']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAsset>>,
    { assetId: string }
  > = (props) => {
    const { assetId } = props ?? {}

    return deleteAsset(assetId)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteAssetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAsset>>>

export type DeleteAssetMutationError = unknown

/**
 * @summary Delete Asset
 */
export const useDeleteAsset = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAsset>>,
      TError,
      { assetId: string },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAsset>>,
  TError,
  { assetId: string },
  TContext
> => {
  const mutationOptions = getDeleteAssetMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Get Overview
 */
export const getOverview = (signal?: AbortSignal) => {
  return getOverviewMutator<AffiliateChannelOverviewSchema[]>({
    url: `/v4/affiliates/admin/settlements/overview/`,
    method: 'GET',
    signal,
  })
}

export const getGetOverviewQueryKey = () => {
  return [`/v4/affiliates/admin/settlements/overview/`] as const
}

export const getGetOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getOverview>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverview>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOverviewQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOverview>>> = ({ signal }) =>
    getOverview(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getOverview>>>
export type GetOverviewQueryError = unknown

export function useGetOverview<TData = Awaited<ReturnType<typeof getOverview>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverview>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverview>>,
          TError,
          Awaited<ReturnType<typeof getOverview>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverview<TData = Awaited<ReturnType<typeof getOverview>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverview>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverview>>,
          TError,
          Awaited<ReturnType<typeof getOverview>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverview<TData = Awaited<ReturnType<typeof getOverview>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverview>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Overview
 */

export function useGetOverview<TData = Awaited<ReturnType<typeof getOverview>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverview>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOverviewQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getGetOverviewSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOverview>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOverview>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOverviewQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOverview>>> = ({ signal }) =>
    getOverview(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOverviewSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOverview>>>
export type GetOverviewSuspenseQueryError = unknown

export function useGetOverviewSuspense<
  TData = Awaited<ReturnType<typeof getOverview>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOverview>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverviewSuspense<
  TData = Awaited<ReturnType<typeof getOverview>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOverview>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverviewSuspense<
  TData = Awaited<ReturnType<typeof getOverview>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOverview>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Overview
 */

export function useGetOverviewSuspense<
  TData = Awaited<ReturnType<typeof getOverview>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOverview>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOverviewSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary List Eligible Payouts
 */
export const listEligiblePayouts = (params: ListEligiblePayoutsParams, signal?: AbortSignal) => {
  return listEligiblePayoutsMutator<AffiliateEligiblePayoutSchema[]>({
    url: `/v4/affiliates/admin/settlements/eligible-payouts/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getListEligiblePayoutsQueryKey = (params?: ListEligiblePayoutsParams) => {
  return [
    `/v4/affiliates/admin/settlements/eligible-payouts/`,
    ...(params ? [params] : []),
  ] as const
}

export const getListEligiblePayoutsQueryOptions = <
  TData = Awaited<ReturnType<typeof listEligiblePayouts>>,
  TError = unknown,
>(
  params: ListEligiblePayoutsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEligiblePayouts>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListEligiblePayoutsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEligiblePayouts>>> = ({ signal }) =>
    listEligiblePayouts(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listEligiblePayouts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEligiblePayoutsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEligiblePayouts>>
>
export type ListEligiblePayoutsQueryError = unknown

export function useListEligiblePayouts<
  TData = Awaited<ReturnType<typeof listEligiblePayouts>>,
  TError = unknown,
>(
  params: ListEligiblePayoutsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEligiblePayouts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEligiblePayouts>>,
          TError,
          Awaited<ReturnType<typeof listEligiblePayouts>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEligiblePayouts<
  TData = Awaited<ReturnType<typeof listEligiblePayouts>>,
  TError = unknown,
>(
  params: ListEligiblePayoutsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEligiblePayouts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEligiblePayouts>>,
          TError,
          Awaited<ReturnType<typeof listEligiblePayouts>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEligiblePayouts<
  TData = Awaited<ReturnType<typeof listEligiblePayouts>>,
  TError = unknown,
>(
  params: ListEligiblePayoutsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEligiblePayouts>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Eligible Payouts
 */

export function useListEligiblePayouts<
  TData = Awaited<ReturnType<typeof listEligiblePayouts>>,
  TError = unknown,
>(
  params: ListEligiblePayoutsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEligiblePayouts>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListEligiblePayoutsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getListEligiblePayoutsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listEligiblePayouts>>,
  TError = unknown,
>(
  params: ListEligiblePayoutsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEligiblePayouts>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListEligiblePayoutsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEligiblePayouts>>> = ({ signal }) =>
    listEligiblePayouts(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listEligiblePayouts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEligiblePayoutsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEligiblePayouts>>
>
export type ListEligiblePayoutsSuspenseQueryError = unknown

export function useListEligiblePayoutsSuspense<
  TData = Awaited<ReturnType<typeof listEligiblePayouts>>,
  TError = unknown,
>(
  params: ListEligiblePayoutsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEligiblePayouts>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEligiblePayoutsSuspense<
  TData = Awaited<ReturnType<typeof listEligiblePayouts>>,
  TError = unknown,
>(
  params: ListEligiblePayoutsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEligiblePayouts>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEligiblePayoutsSuspense<
  TData = Awaited<ReturnType<typeof listEligiblePayouts>>,
  TError = unknown,
>(
  params: ListEligiblePayoutsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEligiblePayouts>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Eligible Payouts
 */

export function useListEligiblePayoutsSuspense<
  TData = Awaited<ReturnType<typeof listEligiblePayouts>>,
  TError = unknown,
>(
  params: ListEligiblePayoutsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEligiblePayouts>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListEligiblePayoutsSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary List Settlements
 */
export const listSettlements = (params?: ListSettlementsParams, signal?: AbortSignal) => {
  return listSettlementsMutator<AffiliateSettlementListSchema[]>({
    url: `/v4/affiliates/admin/settlements/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getListSettlementsQueryKey = (params?: ListSettlementsParams) => {
  return [`/v4/affiliates/admin/settlements/`, ...(params ? [params] : [])] as const
}

export const getListSettlementsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSettlements>>,
  TError = unknown,
>(
  params?: ListSettlementsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSettlements>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListSettlementsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSettlements>>> = ({ signal }) =>
    listSettlements(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSettlements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSettlementsQueryResult = NonNullable<Awaited<ReturnType<typeof listSettlements>>>
export type ListSettlementsQueryError = unknown

export function useListSettlements<
  TData = Awaited<ReturnType<typeof listSettlements>>,
  TError = unknown,
>(
  params: undefined | ListSettlementsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSettlements>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSettlements>>,
          TError,
          Awaited<ReturnType<typeof listSettlements>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSettlements<
  TData = Awaited<ReturnType<typeof listSettlements>>,
  TError = unknown,
>(
  params?: ListSettlementsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSettlements>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSettlements>>,
          TError,
          Awaited<ReturnType<typeof listSettlements>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSettlements<
  TData = Awaited<ReturnType<typeof listSettlements>>,
  TError = unknown,
>(
  params?: ListSettlementsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSettlements>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Settlements
 */

export function useListSettlements<
  TData = Awaited<ReturnType<typeof listSettlements>>,
  TError = unknown,
>(
  params?: ListSettlementsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSettlements>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSettlementsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getListSettlementsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listSettlements>>,
  TError = unknown,
>(
  params?: ListSettlementsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSettlements>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListSettlementsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSettlements>>> = ({ signal }) =>
    listSettlements(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listSettlements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSettlementsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSettlements>>
>
export type ListSettlementsSuspenseQueryError = unknown

export function useListSettlementsSuspense<
  TData = Awaited<ReturnType<typeof listSettlements>>,
  TError = unknown,
>(
  params: undefined | ListSettlementsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSettlements>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSettlementsSuspense<
  TData = Awaited<ReturnType<typeof listSettlements>>,
  TError = unknown,
>(
  params?: ListSettlementsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSettlements>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSettlementsSuspense<
  TData = Awaited<ReturnType<typeof listSettlements>>,
  TError = unknown,
>(
  params?: ListSettlementsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSettlements>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Settlements
 */

export function useListSettlementsSuspense<
  TData = Awaited<ReturnType<typeof listSettlements>>,
  TError = unknown,
>(
  params?: ListSettlementsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSettlements>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSettlementsSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Create Settlement View
 */
export const createSettlementView = (
  affiliateCreateSettlementSchema: AffiliateCreateSettlementSchema,
  signal?: AbortSignal,
) => {
  return createSettlementViewMutator<AffiliateSettlementDetailSchema>({
    url: `/v4/affiliates/admin/settlements/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: affiliateCreateSettlementSchema,
    signal,
  })
}

export const getCreateSettlementViewMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSettlementView>>,
    TError,
    { data: AffiliateCreateSettlementSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSettlementView>>,
  TError,
  { data: AffiliateCreateSettlementSchema },
  TContext
> => {
  const mutationKey = ['createSettlementView']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSettlementView>>,
    { data: AffiliateCreateSettlementSchema }
  > = (props) => {
    const { data } = props ?? {}

    return createSettlementView(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateSettlementViewMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSettlementView>>
>
export type CreateSettlementViewMutationBody = AffiliateCreateSettlementSchema
export type CreateSettlementViewMutationError = unknown

/**
 * @summary Create Settlement View
 */
export const useCreateSettlementView = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSettlementView>>,
      TError,
      { data: AffiliateCreateSettlementSchema },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createSettlementView>>,
  TError,
  { data: AffiliateCreateSettlementSchema },
  TContext
> => {
  const mutationOptions = getCreateSettlementViewMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Get Settlement
 */
export const getSettlement = (settlementId: string, signal?: AbortSignal) => {
  return getSettlementMutator<AffiliateSettlementDetailSchema>({
    url: `/v4/affiliates/admin/settlements/${settlementId}/`,
    method: 'GET',
    signal,
  })
}

export const getGetSettlementQueryKey = (settlementId?: string) => {
  return [`/v4/affiliates/admin/settlements/${settlementId}/`] as const
}

export const getGetSettlementQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettlement>>,
  TError = unknown,
>(
  settlementId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettlement>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettlementQueryKey(settlementId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettlement>>> = ({ signal }) =>
    getSettlement(settlementId, signal)

  return { queryKey, queryFn, enabled: !!settlementId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettlement>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettlementQueryResult = NonNullable<Awaited<ReturnType<typeof getSettlement>>>
export type GetSettlementQueryError = unknown

export function useGetSettlement<
  TData = Awaited<ReturnType<typeof getSettlement>>,
  TError = unknown,
>(
  settlementId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettlement>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettlement>>,
          TError,
          Awaited<ReturnType<typeof getSettlement>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettlement<
  TData = Awaited<ReturnType<typeof getSettlement>>,
  TError = unknown,
>(
  settlementId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettlement>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettlement>>,
          TError,
          Awaited<ReturnType<typeof getSettlement>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettlement<
  TData = Awaited<ReturnType<typeof getSettlement>>,
  TError = unknown,
>(
  settlementId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettlement>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Settlement
 */

export function useGetSettlement<
  TData = Awaited<ReturnType<typeof getSettlement>>,
  TError = unknown,
>(
  settlementId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettlement>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettlementQueryOptions(settlementId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getGetSettlementSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettlement>>,
  TError = unknown,
>(
  settlementId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSettlement>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettlementQueryKey(settlementId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettlement>>> = ({ signal }) =>
    getSettlement(settlementId, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getSettlement>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettlementSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettlement>>
>
export type GetSettlementSuspenseQueryError = unknown

export function useGetSettlementSuspense<
  TData = Awaited<ReturnType<typeof getSettlement>>,
  TError = unknown,
>(
  settlementId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSettlement>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettlementSuspense<
  TData = Awaited<ReturnType<typeof getSettlement>>,
  TError = unknown,
>(
  settlementId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSettlement>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettlementSuspense<
  TData = Awaited<ReturnType<typeof getSettlement>>,
  TError = unknown,
>(
  settlementId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSettlement>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Settlement
 */

export function useGetSettlementSuspense<
  TData = Awaited<ReturnType<typeof getSettlement>>,
  TError = unknown,
>(
  settlementId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSettlement>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettlementSuspenseQueryOptions(settlementId, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Update Settlement View
 */
export const updateSettlementView = (
  settlementId: string,
  affiliateUpdateSettlementPayoutsSchema: AffiliateUpdateSettlementPayoutsSchema,
) => {
  return updateSettlementViewMutator<AffiliateSettlementDetailSchema>({
    url: `/v4/affiliates/admin/settlements/${settlementId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: affiliateUpdateSettlementPayoutsSchema,
  })
}

export const getUpdateSettlementViewMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSettlementView>>,
    TError,
    { settlementId: string; data: AffiliateUpdateSettlementPayoutsSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSettlementView>>,
  TError,
  { settlementId: string; data: AffiliateUpdateSettlementPayoutsSchema },
  TContext
> => {
  const mutationKey = ['updateSettlementView']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSettlementView>>,
    { settlementId: string; data: AffiliateUpdateSettlementPayoutsSchema }
  > = (props) => {
    const { settlementId, data } = props ?? {}

    return updateSettlementView(settlementId, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateSettlementViewMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSettlementView>>
>
export type UpdateSettlementViewMutationBody = AffiliateUpdateSettlementPayoutsSchema
export type UpdateSettlementViewMutationError = unknown

/**
 * @summary Update Settlement View
 */
export const useUpdateSettlementView = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSettlementView>>,
      TError,
      { settlementId: string; data: AffiliateUpdateSettlementPayoutsSchema },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateSettlementView>>,
  TError,
  { settlementId: string; data: AffiliateUpdateSettlementPayoutsSchema },
  TContext
> => {
  const mutationOptions = getUpdateSettlementViewMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Cancel Settlement View
 */
export const cancelSettlementView = (settlementId: string) => {
  return cancelSettlementViewMutator<CancelSettlementView200>({
    url: `/v4/affiliates/admin/settlements/${settlementId}/`,
    method: 'DELETE',
  })
}

export const getCancelSettlementViewMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelSettlementView>>,
    TError,
    { settlementId: string },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelSettlementView>>,
  TError,
  { settlementId: string },
  TContext
> => {
  const mutationKey = ['cancelSettlementView']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelSettlementView>>,
    { settlementId: string }
  > = (props) => {
    const { settlementId } = props ?? {}

    return cancelSettlementView(settlementId)
  }

  return { mutationFn, ...mutationOptions }
}

export type CancelSettlementViewMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelSettlementView>>
>

export type CancelSettlementViewMutationError = unknown

/**
 * @summary Cancel Settlement View
 */
export const useCancelSettlementView = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelSettlementView>>,
      TError,
      { settlementId: string },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cancelSettlementView>>,
  TError,
  { settlementId: string },
  TContext
> => {
  const mutationOptions = getCancelSettlementViewMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Confirm Settlement View
 */
export const confirmSettlementView = (settlementId: string, signal?: AbortSignal) => {
  return confirmSettlementViewMutator<AffiliateSettlementDetailSchema>({
    url: `/v4/affiliates/admin/settlements/${settlementId}/confirm/`,
    method: 'POST',
    signal,
  })
}

export const getConfirmSettlementViewMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmSettlementView>>,
    TError,
    { settlementId: string },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmSettlementView>>,
  TError,
  { settlementId: string },
  TContext
> => {
  const mutationKey = ['confirmSettlementView']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmSettlementView>>,
    { settlementId: string }
  > = (props) => {
    const { settlementId } = props ?? {}

    return confirmSettlementView(settlementId)
  }

  return { mutationFn, ...mutationOptions }
}

export type ConfirmSettlementViewMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmSettlementView>>
>

export type ConfirmSettlementViewMutationError = unknown

/**
 * @summary Confirm Settlement View
 */
export const useConfirmSettlementView = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof confirmSettlementView>>,
      TError,
      { settlementId: string },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof confirmSettlementView>>,
  TError,
  { settlementId: string },
  TContext
> => {
  const mutationOptions = getConfirmSettlementViewMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Process Settlement View
 */
export const processSettlementView = (settlementId: string, signal?: AbortSignal) => {
  return processSettlementViewMutator<AffiliateSettlementDetailSchema>({
    url: `/v4/affiliates/admin/settlements/${settlementId}/process/`,
    method: 'POST',
    signal,
  })
}

export const getProcessSettlementViewMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processSettlementView>>,
    TError,
    { settlementId: string },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof processSettlementView>>,
  TError,
  { settlementId: string },
  TContext
> => {
  const mutationKey = ['processSettlementView']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof processSettlementView>>,
    { settlementId: string }
  > = (props) => {
    const { settlementId } = props ?? {}

    return processSettlementView(settlementId)
  }

  return { mutationFn, ...mutationOptions }
}

export type ProcessSettlementViewMutationResult = NonNullable<
  Awaited<ReturnType<typeof processSettlementView>>
>

export type ProcessSettlementViewMutationError = unknown

/**
 * @summary Process Settlement View
 */
export const useProcessSettlementView = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof processSettlementView>>,
      TError,
      { settlementId: string },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof processSettlementView>>,
  TError,
  { settlementId: string },
  TContext
> => {
  const mutationOptions = getProcessSettlementViewMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Export Settlement Csv
 */
export const exportSettlementCsv = (settlementId: string, signal?: AbortSignal) => {
  return exportSettlementCsvMutator<void>({
    url: `/v4/affiliates/admin/settlements/${settlementId}/export.csv`,
    method: 'GET',
    signal,
  })
}

export const getExportSettlementCsvQueryKey = (settlementId?: string) => {
  return [`/v4/affiliates/admin/settlements/${settlementId}/export.csv`] as const
}

export const getExportSettlementCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof exportSettlementCsv>>,
  TError = ErrorResponse,
>(
  settlementId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSettlementCsv>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getExportSettlementCsvQueryKey(settlementId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportSettlementCsv>>> = ({ signal }) =>
    exportSettlementCsv(settlementId, signal)

  return { queryKey, queryFn, enabled: !!settlementId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportSettlementCsv>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportSettlementCsvQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportSettlementCsv>>
>
export type ExportSettlementCsvQueryError = ErrorResponse

export function useExportSettlementCsv<
  TData = Awaited<ReturnType<typeof exportSettlementCsv>>,
  TError = ErrorResponse,
>(
  settlementId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportSettlementCsv>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportSettlementCsv>>,
          TError,
          Awaited<ReturnType<typeof exportSettlementCsv>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportSettlementCsv<
  TData = Awaited<ReturnType<typeof exportSettlementCsv>>,
  TError = ErrorResponse,
>(
  settlementId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportSettlementCsv>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportSettlementCsv>>,
          TError,
          Awaited<ReturnType<typeof exportSettlementCsv>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportSettlementCsv<
  TData = Awaited<ReturnType<typeof exportSettlementCsv>>,
  TError = ErrorResponse,
>(
  settlementId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSettlementCsv>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export Settlement Csv
 */

export function useExportSettlementCsv<
  TData = Awaited<ReturnType<typeof exportSettlementCsv>>,
  TError = ErrorResponse,
>(
  settlementId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSettlementCsv>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getExportSettlementCsvQueryOptions(settlementId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getExportSettlementCsvSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof exportSettlementCsv>>,
  TError = ErrorResponse,
>(
  settlementId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportSettlementCsv>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getExportSettlementCsvQueryKey(settlementId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportSettlementCsv>>> = ({ signal }) =>
    exportSettlementCsv(settlementId, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof exportSettlementCsv>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportSettlementCsvSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportSettlementCsv>>
>
export type ExportSettlementCsvSuspenseQueryError = ErrorResponse

export function useExportSettlementCsvSuspense<
  TData = Awaited<ReturnType<typeof exportSettlementCsv>>,
  TError = ErrorResponse,
>(
  settlementId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportSettlementCsv>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportSettlementCsvSuspense<
  TData = Awaited<ReturnType<typeof exportSettlementCsv>>,
  TError = ErrorResponse,
>(
  settlementId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportSettlementCsv>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportSettlementCsvSuspense<
  TData = Awaited<ReturnType<typeof exportSettlementCsv>>,
  TError = ErrorResponse,
>(
  settlementId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportSettlementCsv>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export Settlement Csv
 */

export function useExportSettlementCsvSuspense<
  TData = Awaited<ReturnType<typeof exportSettlementCsv>>,
  TError = ErrorResponse,
>(
  settlementId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportSettlementCsv>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getExportSettlementCsvSuspenseQueryOptions(settlementId, options)

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = queryOptions.queryKey

  return query
}
